<template>
  <div>
    <div class="dialog-bg" v-if="dialogShow" @click="cancelDialog" >
    <div class="img-close" style="top: 0">
      <img style="width: 20px" src="../../../../assets/img/closeWhite.png"  @click="cancelDialog" alt="">
    </div>

    <!-- <div class="dialog-container" > -->
      <!-- <div class="dialog-main" > -->
        <div class="input_module_content" @click.stop @mousedown="moveDialog">
        <!-- <div>
          <img src="../../../../assets/img/close.png" alt="" class="close_dialog" @mousedown.stop @click="cancelDialog">
        </div> -->
        <div class="exchange_rate" @mousedown.stop>
          <template v-if="inputData.sellerInfo.input.countrySite.data != 0 && inputData.sellerInfo.input.countrySite.data != 1">
            <span @mouseover="showCalmDetail(8)" @mouseleave="cancelCalmDetail(8)" :class="{title_orange:showDetailCalm[8]}" style="margin-right: 10px;display: inline-block">
              <span v-if="inputData.sellerInfo.input.countrySite.data == 7">日本地方消费税税率:<b>7.8%</b></span>
              <span v-else>{{ country_self[inputData.sellerInfo.input.countrySite.data] }}商品销售增值税税率:<b>{{ (importVAT * 100).toFixed(1) }}%</b></span>
            </span>
          </template>
          <span style="margin-right: 10px">
            {{ RateName[inputData.sellerInfo.input.countrySite.data] }}/RMB即时汇率:<b>{{ Rate[inputData.sellerInfo.input.countrySite.data] }}</b>
          </span>
          <span style="margin-right: 10px;position: relative;" @mouseover="showCalmDetail(18)" @mouseleave="cancelCalmDetail(18)" :class="{title_orange:showDetailCalm[18] && inputData.sellerInfo.input.sellerType.data === 1}">
            {{ secondTitle[inputData.sellerInfo.input.sellerType.data] }}:
            <img src="../img/问号.png" class="question-img" v-if="inputData.sellerInfo.input.sellerType.data === 1">
            <span class="curr_self">
              ({{countryCurrency_self[0]}})
              <!--              ({{countryCurrency_self[inputData.sellerInfo.input.countrySite.data]}})-->
            </span>
            <b>
            {{nationalCurrency_self[0]}}{{ membershipFee[inputData.sellerInfo.input.sellerType.data][0] }}/月

<!--              {{inputData.sellerInfo.input.sellerType.data}}-->
<!--              {{nationalCurrency_self[inputData.sellerInfo.input.countrySite.data]}}{{ membershipFee[inputData.sellerInfo.input.sellerType.data][inputData.sellerInfo.input.countrySite.data] }}/月-->
            </b>
            <span class="cost_detail3" style="width: 420px;left: -490px;"  v-show="showDetailCalm[18] && inputData.sellerInfo.input.sellerType.data === 1">
                <p>
                    对于“个人销售计划”帐户，除销售佣金外,亚马逊对每个商品另收取: $0.99；
                </p>
              </span>
          </span>
          <span style="margin-right: 10px">
            月仓储费:
            <span class="curr_self">
            ({{countryCurrency_self[inputData.sellerInfo.input.countrySite.data]}})
            </span>
            <b>{{ warehouseFeeMonthly }}/m³</b>
          </span>
        </div>
        <div class="input_total_module" @mousedown.stop>
          <div class="input_content_title">FBA商品原始数据</div>
          <div v-for="(item, index) in inputData" :key="index" class="input_module">
            <span class="input_title">{{item.title}}</span>
            <span class="input_unit input_btn" v-if="index === 'packData' && isChange" @click="unitClick">英美制转换</span>
            <span class="input_unit" style="color: #00a0c7;font-weight: bold" v-if="index === 'operatingExpenses'">(仅针对该商品)</span>
            <div v-for="(itemInput, i) in item.input" :key="i" class="input_content">
              <div v-if="itemInput.isShow" style="display: flex" class="input_content1">
                <div :class="{input_name_1: index === 'packData', input_name_3: index === 'stockCost',
              input_name_2: index === 'sellerInfo' || index === 'operatingExpenses' || index === 'productRevenue'}">
            <span @mouseover="showDetail(index, i)" class="input_item_title" @mouseleave="cancelDetail(index, i)"
                  :class="{title_orange:itemInput.showDetail && itemInput.detail, title_red: i === 'taxExpense' || i === 'saleTax' || i === 'importTariff'}">
              {{itemInput.name}}
              <template v-if="i === 'stockPrice'">
                <span class="curr_self" v-if="inputData.stockCost.input.xxts.data == 0">(含税)</span>
                <span class="curr_self" v-else>(不含税)</span>
              </template>
              <span v-if="itemInput.showDetail && itemInput.detail && index !== 'productRevenue'" :style="{'width':itemInput.width}" :class="itemInput.name === '销售佣金率' ? 'input_item_detail2':'input_item_detail'">
                <div v-html="itemInput.detail"></div>
                <div v-if="itemInput.name === '销售佣金率'" style="margin-top: 5px;">
                  亚马逊类目VS销售佣金率：<br>
                  <div style="padding: 0 15px">
                    <ul>
                    <li>家居和园艺：15%；</li>
                    <li>厨具：15%；</li>
                    <li>办公用品：15%；</li>
                    <li>户外运动：15%</li>
                    <li>工具和家居整修：15%；</li>
                    <li>基础电动工具：12%；</li>
                    <li>3D打印商品：12%；</li>
                    <li>箱包和旅行用品：15%</li>
                    <li>家具和灯饰：15%；</li>
                    <li>乐器：15%；</li>
                    <li>个人电脑 ：6%；</li>
                    <li>宠物用品：15%；</li>
                    <li>玩具和游戏类：15%；</li>
                    <li>服装和配饰：17%；</li>
                    <li>图书收藏品：15%；</li>
                    <li>母婴商品不包括婴儿服饰：价格不超过$10是8%，价格超过$10是15%；</li>
                    <li>大型家电：总售价中$300以内15%；总售价中$300以上8%；</li>
                    <li>汽车和户外动力设备：汽车用品12%；轮胎和车轮商品为10%；</li>
                    <li>个护健康(含个人护理器具)：价格不超过$10是8%，价格超过$10是15%；</li>
                    <li>珠宝首饰：总售价中不超过$250是20%，总售价中超过$250是5%；</li>
                    <li>美容：价格不超过$10是8%，价格超过$10是15%；</li>
                    <li>食品类》价格不超过$15是8%，价格超过$15是15%；</li>
                    <li>钟表：总售价中不超过$1500是16%，总售价中超过$1500是3%；</li>
                    <li>鞋靴、手提包和太阳镜：总售价中不超过$75是15% ，总售价中超过$75是18%；</li>
                    <li>电子商品及配件：总售价中不超过$100是15% ，总售价中超过$100是8%；</li>
                  </ul>
                  </div>
                </div>
              </span>
              <span v-else-if="itemInput.showDetail &&   itemInput.detail !== '' && index === 'productRevenue'" :style="{'width': itemInput.width}" class="input_item_detail3">
                <div v-html="itemInput.detail"></div>
              </span>
            </span>
                  <span v-if="i === 'advertisingFee' || i === 'sellingPrice'"
                        class="curr_self">({{countryCurrency_self[inputData.sellerInfo.input.countrySite.data]}})</span>
                </div>
                <label class="input_detail"  :class="{isInput: !itemInput.isInput, disInput:!isChange, isDisable:itemInput.isDisable && i === 'importTariff'}">
                  <div class="input_icon" :class="{special_icon: itemInput.icon[0] !== '￥'}"
                       v-if="itemInput.type !== 'select' && (index === 'operatingExpenses' || index === 'productRevenue')">
                    {{itemInput.icon[inputData.sellerInfo.input.countrySite.data]}}
                  </div>
                  <div class="input_icon" :class="{special_icon: itemInput.icon[0] !== '￥'}"
                       v-else>{{itemInput.icon[0]}}</div>
                  <input class="disable_text" type="text" v-if="i === 'warehouseConfiguration' && inputData.sellerInfo.input.countrySite.data !== 0"
                          disabled v-model="text">
                  <select class="select_text" :name="item.title" id="0" v-else-if="itemInput.type=== 'select'" @change="optionClick(index,i)"
                          v-model="itemInput.data" @blur="selectBlur(itemInput.data,index,i)" :disabled="!isChange || itemInput.isDisable">
                    <option :value="index1" v-for="(array, index1) in itemInput.array" :key="array" >{{array}}</option>
                  </select>
                  <input class="input_text" type="number" v-else v-model="itemInput.data"
                         @blur="clearNumber(itemInput.data,index,i)" @focus="getInput(index, i)" :disabled="!isChange">
                  <span v-if="i === 'operatingAnnualInterestRate' || i === 'recoveryLossRate' || i === 'commission' || i === 'salesCommission' || i === 'operationCommission' || i === 'sprkgsl'">%</span>
                </label>
                <div class="input_unit" v-if="index === 'packData'">{{itemInput.unit[unitIndex]}}</div>
                <div class="input_unit" v-else-if="index !== 'operatingExpenses' && index !== 'sellerInfo'">
                  <template v-if="i === 'sqbs'">
                    <i class="el-icon-loading" style="color:black;" v-show="showLoadingIcon1"></i>
                  </template>
                  <template v-else-if="i === 'importTariff'">
                    <div class="triangle-down" style="top:4px;right: 15px;" @click="openTriVis(0)"></div>
                  </template>
                  <template v-else>
                    {{itemInput.unit[inputData.packData.input.unit.data]}}
                  </template>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="new-tipss">温馨提示：注册会员后，可在后台“运营”目录内进行更快，更准确，更详细的“选品利润预算”，“在售商品，店铺，公司3个层级的利润核算”以及“进销存财ERP”等功能！ <span @click="linkRegister" style="text-decoration: underline;
        color: #00a0c7;">点击马上注册会员</span></div>
        <div class="cost_content" @mousedown.stop>
          <div class="cost_left_content">
            <span class="cost_title">商品成本与费用分摊
<!--              <span style="color: #c60000;font-size: 14px">(亚马逊站内外各细分项成本与费用分摊)</span>-->
            </span>
            <div class="cost_left_total" @mousedown.stop>
              <div class="cost_left_column">
                <div class="cost_left_row">
                  <span class="cost_left_row_title">
                    采购单价:
                    <template>
                      <span class="curr_self" v-if="inputData.stockCost.input.xxts.data == 0">(含税)</span>
                      <span class="curr_self" v-else>(不含税)</span>
                    </template>
                  </span>
                  <span class="cost_left_row_right">￥{{PPCost}}/套</span>
                </div>
                <div class="cost_left_row"><span class="cost_left_row_title">国内段单位运费:</span><span class="cost_left_row_right">￥{{DUFreight}}/套</span></div>
                <div class="cost_left_row"><span class="cost_left_row_title">国际段单位运费:</span><span class="cost_left_row_right">￥{{IUFreight}}/套</span></div>
                <div class="cost_left_row" @mouseover="showCalmDetail(0)" @mouseleave="cancelCalmDetail(0)">
                  <span class="cost_left_row_title"  :class="{title_orange:showDetailCalm[0]}">亚马逊销售佣金:<img src="../img/问号.png" style="width:12px"></span>
                  <span class="cost_left_row_right">￥{{ACommission}}/套</span>
                  <span class="cost_detail" style="width: 300px;" v-show="showDetailCalm[0]">
                    <p>根据商品原始数据里输入的亚马逊佣金率及商品售价,</p>
                    <p>计算所得的单位商品的销售佣金。</p>
                  </span>
                </div>
                <div class="cost_left_row" @mouseover="showCalmDetail(1)" @mouseleave="cancelCalmDetail(1)">
                  <span class="cost_left_row_title"  :class="{title_orange:showDetailCalm[1]}">当地配送费:<img src="../img/问号.png" style="width:12px"></span>
                  <span class="cost_left_row_right">￥{{ALShipping}}/套</span>
                  <span class="cost_detail" style="width: 450px" v-show="showDetailCalm[1]">
                    <p>
                        指亚马逊根据不同商品分类,重量,体积等计算得出的当地运费。
                    </p>
                    <p>
                        备注：您可以在后台商品Listing里查看显示的当地运费跟我们系统计算出
                    </p>
                    <p>
                        的运费是否一致；如果不一致,请注意较对您刚才输入的商品尺寸,重量,分类,
                    </p>
                    <p >
                        跟您在亚马逊后台商品Listing里已上传的对应项数据是否一致）；
                    </p>
                  </span>
                </div>

                <div class="cost_left_row" @mouseleave="cancelCalmDetail(3)">
                    <span class="cost_left_row_title" @mouseover="showCalmDetail(3)" :class="{title_orange:showDetailCalm[3]}">入口国综合税费:</span>
                    <span class="cost_left_row_right">￥{{rkgzhsf}}/套<div class="triangle-down" @click="openTriVis(1)"></div></span>
                    <span class="cost_detail1" @mouseover="showCalmDetail(3)" v-show="showDetailCalm[3] && inputData.sellerInfo.input.countrySite.data == 0">
                      <p style="font-weight: bold">对于美国商品入口税费</p>
                      <p>商品入口税费 =  Import Duty(关税) + ADV(清关杂费)</p>
                      <p> Import Duty = 货物申报价值 x 商品关税税率</p>
                      <p>(备注: 对于美国亚马逊FBA物流渠道通常包含双清服务，可忽略ADV(清关杂费)；当物流费用含双清及包税时,商品入口税费可视为0，否则可在本计算系统的"商品入口税费"框输入实际关税及清关杂费总额，系统将自动分摊计算单位关税额)</p>
                      <p style="font-weight: bold">对于美国综合税(CST)税率</p>
                      <p>美国没有VAT增值税或GST商品及服务税，但有"综合销售税CST"(不同州CST税率不同); 另外,在购买亚马逊商品时由亚马逊买家承担该税项,因此我们可以简单理解为亚马逊卖家承担的CST为0;</p>
                    </span>
                    <span class="cost_detail1" @mouseover="showCalmDetail(3)" v-show="showDetailCalm[3] && inputData.sellerInfo.input.countrySite.data == 1">
                      <p style="font-weight: bold">对于加拿大商品入口税费</p>
                      <p>商品入口税费 =  Import Duty(关税) + ADV(清关杂费)</p>
                      <p> Import Duty = 货物申报价值 x 商品关税税率</p>
                      <p>(备注: 对于加拿大亚马逊FBA物流渠道通常包含双清服务，可忽略ADV(清关杂费)；当物流费用含双清及包税时,商品入口税费可视为0，否则可在本计算系统的"商品入口税费"框输入实际关税及清关杂费总额，系统将自动分摊计算单位关税额)</p>
                      <p style="font-weight: bold">对于加拿大的GST及PST</p>
                      <p>加拿大GST是指商品及服务税，全国统一税率为5.3％，PST指省税，加拿大各省略有微差，多伦多（安大略省）PST是8％；但由于GST及PST由亚马逊买家在购买商品时承担该税项,因此我们可以简单理解为亚马逊卖家承担的GST及PST为0；</p>
                      <p>实际缴纳税额  = GST + 省消费税PST - Import Duty </p>
                      <p>①GST  = （税后销售价格/（1+GST税率5.3%）*GST税率5.3% </p>
                      <p>②省消费税PST = （税后销售价格/（1+省销售税税率）*省销售税税率  </p>
                    </span>
                    <span class="cost_detail1" @mouseover="showCalmDetail(3)" v-show="showDetailCalm[3] && inputData.sellerInfo.input.countrySite.data == 2">
                      <p style="font-weight: bold">对于英国商品入口税费</p>
                      <p>商品入口税费 = Import Duty + Import VAT + ADV(清关杂费)</p>
                      <p>①Import Duty (入口关税) = 货物申报价值 x 商品关税税率（需根据实际商品确定关税税率）</p>
                      <p>②Import VAT (入口增值税) =（货物申报价值 + CIF运费 + Duty）x 20%   </p>
                      <p>(备注: 对于英国等欧洲亚马逊FBA物流渠道通常包含双清服务，可忽略ADV(清关杂费)；当物流费用含双清及包税时,商品入口税费可视为0（英国等欧洲国家对于Import Duty及Import VAT暂可进行递延，当销售发生后，将根据“实际缴纳税额  = Sale VAT - Import VAT - Import Duty - 其他可抵扣”进行缴税），否则可在本计算系统的"商品入口税费"框输入实际关税及清关杂费总额，系统将自动分摊计算单位关税额)</p>
                      <p style="font-weight: bold">对于英国实缴纳税额</p>
                      <p>英国Sale VAT 是指商品销售增值税，Sale VAT (销售增值税) =（税后销售价格/（1+税率20%）*税率20%；</p>
                      <p>实际缴纳税额  = Sale VAT - Import VAT - Import Duty - 其他可抵扣</p>
                      <p>①Import Duty (入口关税) = 货物申报价值 x 商品关税税率</p>
                      <p>②Import VAT (入口增值税) =（货物申报价值 + CIF运费 + Duty）x 20%   </p>
                      <p>③Sale VAT (销售增值税) =（税后销售价格/（1+税率20%）*税率20%       </p>
                    </span>
                    <span class="cost_detail1" @mouseover="showCalmDetail(3)" v-show="showDetailCalm[3] && inputData.sellerInfo.input.countrySite.data == 3">
                      <p style="font-weight: bold">对于德国商品入口税费</p>
                      <p>商品入口税费 = Import Duty + Import VAT + ADV(清关杂费)</p>
                      <p>①Import Duty (入口关税) = 货物申报价值 x 商品关税税率（需根据实际商品确定关税税率）</p>
                      <p>②Import VAT (入口增值税) =（货物申报价值 + CIF运费 + Duty）x 19%   </p>
                      <p>(备注: 对于德国等欧洲亚马逊FBA物流渠道通常包含双清服务，可忽略ADV(清关杂费)；当物流费用含双清及包税时,商品入口税费可视为0（德国等欧洲国家对于Import Duty及Import VAT暂可进行递延，当销售发生后，将根据“实际缴纳税额  = Sale VAT - Import VAT - Import Duty - 其他可抵扣”进行缴税），否则可在本计算系统的"商品入口税费"框输入实际关税及清关杂费总额，系统将自动分摊计算单位关税额)</p>
                      <p style="font-weight: bold">对于德国实缴纳税额</p>
                      <p>德国Sale VAT 是指商品销售增值税，Sale VAT (销售增值税) =（税后销售价格/（1+税率19%）*税率19%；</p>
                      <p>实际缴纳税额  = Sale VAT - Import VAT - Import Duty - 其他可抵扣</p>
                      <p>①Import Duty (入口关税) = 货物申报价值 x 商品关税税率</p>
                      <p>②Import VAT (入口增值税) =（货物申报价值 + CIF运费 + Duty）x 19%   </p>
                      <p>③Sale VAT (销售增值税) =（税后销售价格/（1+税率19%）*税率19%       </p>
                    </span>
                    <span class="cost_detail1" @mouseover="showCalmDetail(3)" v-show="showDetailCalm[3] && inputData.sellerInfo.input.countrySite.data == 4">
                      <p style="font-weight: bold">对于法国商品入口税费</p>
                      <p>商品入口税费 = Import Duty + Import VAT + ADV(清关杂费)</p>
                      <p>①Import Duty (入口关税) = 货物申报价值 x 商品关税税率（需根据实际商品确定关税税率）</p>
                      <p>②Import VAT (入口增值税) =（货物申报价值 + CIF运费 + Duty）x 20%   </p>
                      <p>(备注: 对于法国等欧洲亚马逊FBA物流渠道通常包含双清服务，可忽略ADV(清关杂费)；当物流费用含双清及包税时,商品入口税费可视为0（法国等欧洲国家对于Import Duty及Import VAT暂可进行递延，当销售发生后，将根据“实际缴纳税额  = Sale VAT - Import VAT - Import Duty - 其他可抵扣”进行缴税），否则可在本计算系统的"商品入口税费"框输入实际关税及清关杂费总额，系统将自动分摊计算单位关税额)</p>
                      <p style="font-weight: bold">对于法国实缴纳税额</p>
                      <p>法国Sale VAT 是指商品销售增值税，Sale VAT (销售增值税) =（税后销售价格/（1+税率20%）*税率20%；</p>
                      <p>实际缴纳税额  = Sale VAT - Import VAT - Import Duty - 其他可抵扣</p>
                      <p>①Import Duty (入口关税) = 货物申报价值 x 商品关税税率</p>
                      <p>②Import VAT (入口增值税) =（货物申报价值 + CIF运费 + Duty）x 20%   </p>
                      <p>③Sale VAT (销售增值税) =（税后销售价格/（1+税率20%）*税率20%       </p>
                    </span>
                    <span class="cost_detail1" @mouseover="showCalmDetail(3)" v-show="showDetailCalm[3] && inputData.sellerInfo.input.countrySite.data == 5">
                      <p style="font-weight: bold">对于意大利商品入口关税</p>
                      <p>商品入口支付 = Import Duty + Import VAT + ADV(清关杂费)</p>
                      <p>①Import Duty (入口关税) = 货物申报价值 x 商品关税税率（需根据实际商品确定关税税率）</p>
                      <p>②Import VAT (入口增值税) =（货物申报价值 + CIF运费 + Duty）x 22%   </p>
                      <p>(备注: 对于意大利等欧洲亚马逊FBA物流渠道通常包含双清服务，可忽略ADV(清关杂费)；当物流费用含双清及包税时,商品入口关税可视为0（意大利等欧洲国家对于Import Duty及Import VAT暂可进行递延，当销售发生后，将根据“实际缴纳税额  = Sale VAT - Import VAT - Import Duty - 其他可抵扣”进行缴税），否则可在本计算系统的"商品入口关税"框输入实际关税总额，系统将自动分摊计算单位关税额)</p>
                      <p style="font-weight: bold">对于意大利实缴纳税额</p>
                      <p>意大利Sale VAT 是指商品销售增值税，Sale VAT (销售增值税) =（税后销售价格/（1+税率22%）*税率22%；</p>
                      <p>实际缴纳税额  = Sale VAT - Import VAT - Import Duty - 其他可抵扣</p>
                      <p>①Import Duty (入口关税) = 货物申报价值 x 商品关税税率</p>
                      <p>②Import VAT (入口增值税) =（货物申报价值 + CIF运费 + Duty）x 22%   </p>
                      <p>③Sale VAT (销售增值税) =（税后销售价格/（1+税率22%）*税率22%       </p>
                    </span>
                    <span class="cost_detail1" @mouseover="showCalmDetail(3)" v-show="showDetailCalm[3] && inputData.sellerInfo.input.countrySite.data == 6">
                      <p style="font-weight: bold">对于西班牙商品入口税费</p>
                      <p>商品入口税费 = Import Duty + Import VAT + ADV(清关杂费)</p>
                      <p>①Import Duty (入口关税) = 货物申报价值 x 商品关税税率（需根据实际商品确定关税税率）</p>
                      <p>②Import VAT (入口增值税) =（货物申报价值 + CIF运费 + Duty）x 21%   </p>
                      <p>(备注: 对于西班牙等欧洲亚马逊FBA物流渠道通常包含双清服务，可忽略ADV(清关杂费)；当物流费用含双清及包税时,商品入口税费可视为0（西班牙等欧洲国家对于Import Duty及Import VAT暂可进行递延，当销售发生后，将根据“实际缴纳税额  = Sale VAT - Import VAT - Import Duty - 其他可抵扣”进行缴税），否则可在本计算系统的"商品入口税费"框输入实际关税及清关杂费总额，系统将自动分摊计算单位关税额)</p>
                      <p style="font-weight: bold">对于西班牙实缴纳税额</p>
                      <p>西班牙Sale VAT 是指商品销售增值税，Sale VAT (销售增值税) =（税后销售价格/（1+税率21%）*税率21%；</p>
                      <p>实际缴纳税额  = Sale VAT - Import VAT - Import Duty - 其他可抵扣</p>
                      <p>①Import Duty (入口关税) = 货物申报价值 x 商品关税税率</p>
                      <p>②Import VAT (入口增值税) =（货物申报价值 + CIF运费 + Duty）x 21%   </p>
                      <p>③Sale VAT (销售增值税) =（税后销售价格/（1+税率21%）*税率21%       </p>
                    </span>
                    <span class="cost_detail1" @mouseover="showCalmDetail(3)" v-show="showDetailCalm[3] && inputData.sellerInfo.input.countrySite.data == 7">
                      <p style="font-weight: bold">对于日本的商品入口税费</p>
                      <p>备注：在逆算法下，商品申报价格=【(商品链接的销售价-销售佣金-FBA运费)/ (1+关税税率)】/110%；</p>
                      <p>货物总申报价值 = 商品申报价值 * 商品数量</p>
                      <p>商品入口税费 = Import Duty + 地方消费税 + 清关杂费</p>
                      <p>①Import Duty = 货物总申报价值 * 商品关税税率</p>
                      <p>②地方消费税 = （税后销售价格/（1+税率7.8%）*税率7.8%  </p>
                    </span>
                    <span class="cost_detail1" @mouseover="showCalmDetail(3)" v-show="showDetailCalm[3] && inputData.sellerInfo.input.countrySite.data == 8">
                      <p style="font-weight: bold">对于澳洲商品入口税费</p>
                      <p>商品入口税费 =  Import Duty(入口关税) + Import VAT (入口增值税) + ADV(清关杂费)</p>
                      <p>①Import Duty (进口关税)  = 货物FOB申报价值 x 商品关税税率</p>
                      <p>②Import VAT (进口增值税) =（货物申报价值 + CIF运费 + Duty）x 10 % </p>
                      <p>(备注: 对于澳洲亚马逊FBA物流渠道通常包含双清服务，可忽略ADV(清关杂费)；当物流费用含双清及包税时,商品入口税费可视为0，否则可在本计算系统的"商品入口税费"框输入实际关税及清关杂费总额，系统将自动分摊计算单位关税额)</p>
                      <p style="font-weight: bold">对于澳洲的GST</p>
                      <p>澳洲GST是指商品及服务税，全国统一税率为10％；但由于GST由亚马逊买家在购买商品时承担该税项,因此我们可以简单理解为亚马逊卖家承担的GST为0（澳洲对于Import Duty及Import VAT不进行递延，因此入口商品需要先支付Import Duty及Import VAT； 发生销售后，根据“实际缴纳税额  = Sale VAT - Import VAT - Import Duty - 其他可抵扣”进行缴税或退税），否则可在本计算系统的"商品入口税费"框输入实际关税总额，系统将自动分摊计算单位关税额)</p>
                      <p>实际缴纳税额  = GST(商品及服务税) - Import VAT - Import Duty - 其他可抵扣</p>
                      <p>①Import Duty (进口关税)  = 货物FOB申报价值 x 商品关税税率</p>
                      <p>②Import VAT (进口增值税) =（货物申报价值 + CIF运费 + Duty）x 10 % </p>
                      <p>③GST (商品与服务税) = （税后销售价格/（1+税率10%）*税率10% </p>
                    </span>
                  </div>
              </div>
              <div class="cost_left_column">
              <div class="cost_left_row" @mouseover="showCalmDetail(11)" @mouseleave="cancelCalmDetail(11)" :class="{title_orange:showDetailCalm[11]}">
                  <span class="cost_left_row_title">仓储费用分摊:<img src="../img/问号.png" style="width:12px"></span>
                  <span class="cost_left_row_right">￥{{WCSharing}}/套</span>
                  <span class="cost_detail" style="width: 400px;" v-show="showDetailCalm[11]">
                    <p >
                        系统根据商品的分类，体积，重量，淡旺季不同的每CBM仓储价格，
                    </p>
                    <p>
                        每套商品的平均待仓天数，库存的数量等计算出单位商品的仓储费用。
                    </p>
                  </span>
                </div>
                <div class="cost_left_row" @mouseover="showCalmDetail(12)" @mouseleave="cancelCalmDetail(12)" :class="{title_orange:showDetailCalm[12]}">
                  <span class="cost_left_row_title">合仓设置费:<img src="../img/问号.png" style="width:12px"></span>
                  <span class="cost_left_row_right">￥{{ AWDCFee }}/套</span>
                  <span class="cost_detail" style="width: 480px;" v-show="showDetailCalm[12]">
                    <p>
                        对货物做FBA亚马逊入仓计划时，亚马逊可能对该批货物安排到N个不同仓库进仓，
                    </p>
                    <p>
                        这样导致的结果是您将需要将该批货物分为N批货单独发运到不同的仓库地址，
                    </p>
                    <p>
                        国际物流运费成本及安排发运的操作成本将大大增加。
                    </p>
                    <p>
                        &nbsp;
                    </p>
                    <p>
                        如果通过亚马逊合仓设置,该批货物将可以合并发到同一个亚马逊仓库,但同时亚马逊
                    </p>
                    <p>
                        将针对“该批货物中的每一个商品收取合仓设置费用”。
                    </p>
                    <p>
                        &nbsp;
                    </p>
                    <p>
                        不同的商品，根据其尺寸，重量，类型等，将分为标准件，大件，超大件等，收取
                    </p>
                    <p>
                        不同的合仓配置费用。我们已根据商品信息，智能分析及计算出每套商品的合仓配置
                    </p>
                    <p >
                        费用，放请心使用。
                    </p>
                  </span>
                </div>
                <div class="cost_left_row"><span class="cost_left_row_title">当月站内广告费用分摊:</span><span class="cost_left_row_right">￥{{MACSharing}}/套</span></div>
                <div class="cost_left_row" v-if="false"><span class="cost_left_row_title">当月站内Deal费用分摊:</span><span class="cost_left_row_right">￥{{DealSharing}}/套</span></div>
                  <div class="cost_left_row" v-if="false"><span class="cost_left_row_title">当月站内Coupon费用分摊:</span><span class="cost_left_row_right">￥{{CouponSharing}}/套</span></div>
                <div class="cost_left_row"><span class="cost_left_row_title">当月站外测评费用分摊:</span><span class="cost_left_row_right">￥{{AOMFees}}/套</span></div>
                <div class="cost_left_row"><span class="cost_left_row_title">当月站外引流费用分摊:</span><span class="cost_left_row_right">￥{{OMDCSharing}}/套</span></div>
                <div class="cost_left_row">
                  <span class="cost_left_row_title">
                    <span v-show="inputData.sellerInfo.input.sellerType.data == 0">专业销售卖家帐户月费分摊:</span>
                    <span v-show="inputData.sellerInfo.input.sellerType.data == 1">个人销售计划月费分摊:</span>
                  </span>
                  <span class="cost_left_row_right">￥{{PSMAllocation}}/套</span>
                </div>
                <div class="cost_left_row"><span class="cost_left_row_title">独立网络等运营月费分摊:</span><span class="cost_left_row_right">￥{{AOSMFAllocation}}/套</span></div>



              </div>
              <div class="cost_left_column">
                <div class="cost_left_row"><span class="cost_left_row_title">卖家帐户月均财务费分摊:</span><span class="cost_left_row_right">￥{{FTESharing}}/套</span></div>
                <div class="cost_left_row"><span class="cost_left_row_title">坏品退货损耗分摊:</span><span class="cost_left_row_right">￥{{BPLAllocation}}/套</span></div>
                <div class="cost_left_row" v-if="false"><span class="cost_left_row_title">非坏品退货损耗分摊:</span><span class="cost_left_row_right">￥{{RLAllocation}}/套</span></div>
                <div class="cost_left_row" @mouseover="showCalmDetail(10)" @mouseleave="cancelCalmDetail(10)" :class="{title_orange:showDetailCalm[10]}">
                  <span class="cost_left_row_title">收汇损失:<img src="../img/问号.png" style="width:12px"></span>
                  <span class="cost_left_row_right">￥{{FELoss}}/套</span>
                  <span class="cost_detail" style="width: 600px" v-show="showDetailCalm[10]">
                    <p>
                        单位商品收汇损失 ＝ (单位商品销售额 - 单位商品亚马逊总费用）* 收汇损失率
                    </p>
                    <p>
                        &nbsp;
                    </p>
                    <p>
                        (备注：单位商品亚马逊总费用 = 单位商品的亚马逊销售佣金 + 亚马逊当地运费 + 亚马逊卖家帐户月费分摊 +
                    </p>
                    <p >
                        月广告费用分摊 + 坏品退货损耗分摊 + 仓储费用分摊 + 合仓配置费分摊）
                    </p>
                  </span>
                </div>
                <div class="cost_left_row" @mouseleave="cancelCalmDetail(7)">
                  <span class="cost_left_row_title"  @mouseover="showCalmDetail(7)"  :class="{title_orange:showDetailCalm[7]}">资金运营利息:<img src="../img/问号.png" style="width:12px"></span>
                  <span class="cost_left_row_right">￥{{OPCost}}/套</span>
                  <span class="cost_detail1" style="width: 750px" @mouseover="showCalmDetail(7)" v-show="showDetailCalm[7]">
                    <p>
                        单位商品资金运营利息 = 单位商品到仓成本 * 2 *（当月商品显示销量 + 当月商品当前库存数量）* (资金运营年息率/12) /商品当月显示销量
                    </p>
                    <p>
                        &nbsp;
                    </p>
                    <p>
                        (备注：一个亚马逊FBA商品商品实际的运营供应量粗略地估算，生产，运输途中，每月销量，库存数量各占1/4，所以本系统在计算公式里
                    </p>
                    <p >
                        乘以系数2。这是目前使用的计算方法）；
                    </p>
                  </span>
                </div>
                <div class="cost_left_row"><span class="cost_left_row_title">商品销售提成分摊:</span><span class="cost_left_row_right">￥{{OOCAllocation}}/套</span></div>
                <div class="cost_left_row"><span class="cost_left_row_title">运营管理提成分摊:</span><span class="cost_left_row_right">￥{{PAOperation}}/套</span></div>

              </div>
            </div>
            <div class="cost_left_bottom">
              <span class="left_bottom_left">成本汇总：</span>
              <span class="left_bottom_right" style="position: relative" @mouseover="showCalmDetail(9)" @mouseleave="cancelCalmDetail(9)">
                <span class="change_text" v-show="calType == 0" @click="calType = 1">忽略卖家账户固定费用</span>
                <span class="change_text" style="background-color: #99d8e7;" v-show="calType == 1" @click="calType = 0">计算卖家账户固定费用</span>
                <span class="cost_detail2" style="font-weight: normal;top: -15px;width: 580px;left: -640px" v-show="showDetailCalm[9]">
                  <p>
                      对于卖家帐户固定费用的正确分摊，原则上要按该卖家帐户的所有在售Listing商品的总销量来分摊。
                  </p>
                  <p>
                      但当前是对该商品进行预算,由于暂时没有总销量数据,因此当点击“忽略“或”计算”按钮所得到的两个不同毛利润值,用户可以暂时理解为这个商品的预算毛利润在这两个毛利润值之间。
                  </p>
                </span>
                ￥{{TCost}}/套
              </span>
            </div>
          </div>
          <div class="cost_right_content">
            <div class="cost_title1" >当月销售额,收汇,利润及利润率</div>
            <div class="cost_left_row1 cost_top" ><span class="cost_left_row_title">商品售价:</span><span class="cost_right_row_right">￥{{PRevenue}}/套</span></div>
            <div class="cost_left_row1"><span class="cost_left_row_title">商品净利润:</span><span class="cost_right_row_right">￥{{PGProfit}}/套</span></div>
            <div class="cost_left_row1"  @mouseover="showCalmDetail(13)" @mouseleave="cancelCalmDetail(13)">
              <span class="cost_left_row_title" :class="{title_orange:showDetailCalm[13]}">商品出资成本:<img src="../img/问号.png" style="width:12px"></span>
              <span class="cost_right_row_right">￥{{CostCapital}}/套</span>
              <span class="cost_detail3" v-show="showDetailCalm[13]">
                <p >
                    商品出资成本 =
                </p>
                <p>
                    采购单价 + 国内单位运费 + 国际单位运费 + 商品入口关税（Duty）+ 商品月测评费分摊 +
                </p>
                <p>
                    站外月引流费用分摊 + 独立网络等运营月费分摊 + 卖家帐户月均财务费用分摊；
                </p>
                <p>
                    &nbsp;
                </p>
                <p>
                    (以上8项为每单位的亚马逊FBA商品实际出资成本。其它的费用都在亚马逊帐户销售款中扣取,
                </p>
                <p>
                    不需要卖家额外出资)。
                </p>
              </span>
            </div>
            <div class="cost_left_row1" @mouseover="showCalmDetail(5)" @mouseleave="cancelCalmDetail(5)">
              <span class="cost_left_row_title"  :class="{title_orange:showDetailCalm[5]}">商品收汇:<img src="../img/问号.png" style="width:12px"></span>
              <span class="cost_right_row_right">￥{{APReceipt}}/套</span>
              <span class="cost_detail3" v-show="showDetailCalm[5]">
                <p>
                    指每单位商品销售后扣除亚马逊所有费用后的剩余金额。
                </p>
                <p>
                    &nbsp;
                </p>
                <p>
                    (备注：单位商品的亚马逊费用包括：亚马逊销售佣金，亚马逊当地运费，卖家帐户月费分摊及
                </p>
                <p>
                    月广告费用分摊(该两项费用在“帐户设置”内通常默认设为直接在销售款内扣费,不在信用卡扣费),
                </p>
                <p >
                    坏品退货损耗分摊,非坏品退货损耗,仓储费用分摊,合仓配置费以及收汇损失分摊后的实际收汇。
                </p>
              </span>
            </div>
            <div class="cost_left_row1" @mouseover="showCalmDetail(6)" @mouseleave="cancelCalmDetail(6)">
              <span class="cost_left_row_title"  :class="{title_orange:showDetailCalm[6]}">当月实际销量<span  style="color: #00a0c7;font-size: 10px">(扣减退货)</span>:<img src="../img/问号.png" style="width:12px"></span>
              <span class="cost_right_row_right num-margin" >{{ASales}} 套</span>
              <span class="cost_detail3" style="width: 500px; left: -570px" v-show="showDetailCalm[6]">
                <p >
                    当月实际总销量 = 商品当月显示销量 - 当月坏品退货数 - 当月非坏品退货数。
                </p>
                <p>
                    &nbsp;
                </p>
                <p>
                    补充说明：无论是非坏品或坏品退货，都可能是客户当月或N月前购买但当月退回的商品;
                </p>
                <p>
                    这两类退货商品的总数量存在跨月退回的问题。所以可以简单地将“实际销量&quot; 理解为显示
                </p>
                <p>
                    销售出去的商品数量减去退回来的坏品及非坏品数量&quot;。
                </p>
              </span>
            </div>
            <!-- <div style="height: 10px"></div> -->
            <div class="cost_left_row1"><span class="cost_left_row_title">当月总销售额:</span><span class="cost_right_row_right">￥{{TMPSales}}</span></div>
            <div class="cost_left_row1"><span class="cost_left_row_title">当月总收汇:</span><span class="cost_right_row_right">￥{{TATCOPITMonth}}</span></div>
            <div class="cost_left_row1"><span class="cost_left_row_title">当月总销售利润:</span><span class="cost_right_row_right">￥{{ATGPOTPFTMonth}}</span></div>
            <div class="cost_left_row1" @mouseover="showCalmDetail(17)" @mouseleave="cancelCalmDetail(17)">
                <span class="cost_left_row_title" :class="{title_orange:showDetailCalm[17]}">当月销售利润率:<img src="../img/问号.png" style="width:12px"></span>
                <span class="cost_right_row_right num-margin" >{{salePGMargin}}%</span>
                <span class="cost_detail3" style="width: 360px; left: -430px" v-show="showDetailCalm[17]">
                  <p>
                      当月销售利润率 = （商品净利润/商品售价）* 100%
                  </p>
                  <!-- <p >
                      商品利润 * 当月实际销量 * 100% / (商品出资成本 * 当月实际销量)
                  </p> -->
                </span>
              </div>
              <div class="cost_left_row1" @mouseover="showCalmDetail(18)" @mouseleave="cancelCalmDetail(18)">
                <span class="cost_left_row_title" :class="{title_orange:showDetailCalm[18]}">当月成本利润率:<img src="../img/问号.png" style="width:12px"></span>
                <span class="cost_right_row_right num-margin" >{{PGMargin}}%</span>
                <span class="cost_detail3" style="width: 360px; left: -430px" v-show="showDetailCalm[18]">
                  <p>
                      当月成本利润率 = （商品净利润/成本汇总）* 100%
                  </p>
                  <!-- <p >
                      商品利润 * 当月实际销量 * 100% / (商品出资成本 * 当月实际销量)
                  </p> -->
                </span>
              </div>

          </div>
        </div>
<!--        <div class="new_tips" >温馨提示: 1. 鼠标指向字段将有相应的说明；2. 此弹窗仅显示FBA商品预算利润，保存数据到后台将能更高效准确核算各商品及店铺利润,获得更多运营数据分析！</div>-->
        <div class="btn" @mousedown.stop>
          <button class="calm_button" @click="changeData" v-show="!isChange">修改</button>
          <!-- <button class="calm_button" @click="saveData">马上注册会员</button> -->
        </div>
      </div>
      <!-- </div> -->
    <!-- </div> -->
  </div>
<!--    计算弹窗-->
    <!-- <my-dialog :show="dialogShow" @cancel="$emit('dialogShow', false)">


    </my-dialog> -->
<!--    登录弹窗-->
    <my-dialog :show="isLogin" @cancel="cancelLogin" >
      <img src="../../../../assets/img/close.png" alt="" class="login_close" @click="isLogin = false">
      <div class="login_content">
        <div class="login_title">账户登录</div>
        <label class="input_item">
          <input type="email" @keyup.enter="btnLoginClick" class="input_box" v-model="loginEmail" placeholder="注册邮箱或手机号">
        </label>
        <label class="input_item">
          <input type="password" @keyup.enter="btnLoginClick" class="input_box" v-model="loginPassword" placeholder="请输入密码">
        </label>
        <div style="display: flex">
          <label class="input_item">
            <input type="email" @keyup.enter="btnLoginClick" style="width: 180px;border: 1px solid #e6e6e6" class="registered_input_1" v-model="loginVerity" placeholder="请输入验证码">
          </label>
          <img :src="loginImgSrc" alt="验证码" @click="loginImgClick" class="verity_img">
        </div>
        <!--        手机验证码-->
        <div class="input_info my_input" v-if="doubleLogin" style="width: 340px;margin-left: 10px;border: 1px solid #e6e6e6">
          <label>
            <input type="text" placeholder="请输入手机验证码" style="height: 38px; width: 200px;outline: none;padding: 10px;font-size: 12px;color: #8b8b8b;" v-model="phoneCode">
          </label>
          <div class="my_sent_btn" style="border-left: 1px solid #e6e6e6" v-if="!isSendPhone" @click="sendLoginPhone">点击发送</div>
          <div class="my_sent_btn1" v-else>{{ time2 }} s</div>
        </div>
        <div class="login_fun">
          <span>还没成为会员吗?</span>
          <span @click="loginRegister" class="free-register">免费注册</span>
        </div>
        <div class="login_btn_div">
          <button class="login_btn" @click="btnLoginClick">登录</button>
        </div>
        <div class="bottom-text">
          <div>备注：注册成为会员即可保存商品预算数据到帐户后台；在会员后台随时调出原预算数据，</div>
          <div>轻松更新每月销量,退货量,库存量,广告费,测评费数据等即可实时准确地核算出商品及店铺利润！</div>
        </div>
      </div>
    </my-dialog>
<!--    注册弹窗-->
    <my-dialog :show="isRegister" @cancel="cancelRegister">
      <img src="../../../../assets/img/close.png" alt="" class="login_close" @click="isRegister = false">
      <div class="registered_title">欢迎注册AMZJOIN账户</div>
      <div class="registered_content">
        <!--        登录名-->
        <div class="input_info">
          <label>
            <input type="text" class="registered_input" placeholder="设置登录邮箱" v-model="loginName" @focus="focus1" @blur="blur1">
          </label>
          <span v-show="show1">请设置登录邮箱</span>
        </div>
        <!--        第一次输入密码-->
        <div class="input_info">
          <label>
            <input type="password" class="registered_input" placeholder="请输入密码" v-model="password" @focus="focus2" @blur="blur2">
          </label>
          <span v-show="show2">
            <p>6-20个字符,密码不能是相同的用户名</p>
            <p>只能包含数字、字母以及标点符号(空格除外)</p>
            <p>数字、字母和标点符号至少包含2种</p>
          </span>
        </div>
        <!--        再次输入密码-->
        <div class="input_info">
          <label>
            <input type="password" class="registered_input" placeholder="请再次输入密码" v-model="againPassword" @focus="focus3" @blur="blur3">
          </label>
          <span v-show="show3">请再次输入密码</span>
        </div>
        <!--        验证码-->
        <div style="display: flex">
          <label class="input_item">
            <input type="email" class="registered_input_1" v-model="verity" placeholder="请输入验证码">
          </label>
          <img :src="imgSrc" alt="验证码" @click="imgClick" class="verity_img">
        </div>
        <!--        手机号码-->
        <div class="phone_input_module">
          <label>
            <input type="text" placeholder="请输入手机区号" class="phone_name" v-model="phoneName" disabled>
          </label>
          <label>
            <input type="text" placeholder="请输入手机号码" class="phone_input" v-model="phone">
          </label>
        </div>
        <!--        手机验证码-->
        <div class="input_info my_input">
          <label>
            <input type="text" placeholder="请输入手机验证码" style="height: 38px; width: 200px;outline: none;padding: 10px;font-size: 12px;color: #8b8b8b;" v-model="phoneVerity">
          </label>
          <div class="my_sent_btn" v-if="!time" @click="sendPhone">点击发送</div>
          <div class="my_sent_btn1" v-else>{{ time }} s</div>
        </div>
        <!--        条款-->
        <div class="checkbox_module">
          <label>
            <input type="checkbox" v-model="isAble">
          </label><span @click="navigatorHref(0)">《Amzjoin网站服务条款》</span>|<span @click="navigatorHref(1)">《法律声明和隐私权政策》</span>
        </div>
        <div class="registered_btn_div">
          <button class="registered_btn" :disabled="!isAble" @click="btnRegisterClick">注册</button>
        </div>
      </div>
    </my-dialog>
    <el-dialog
      :title="triVistableType ? '入口国综合税费' : '货物入口税费'"
      :visible.sync="triVistable"
      width="600px"
      :append-to-body="true"
      >
      <template v-if="(inputData.sellerInfo.input.countrySite.data === 2 ||
        inputData.sellerInfo.input.countrySite.data === 3 ||
        inputData.sellerInfo.input.countrySite.data === 4 ||
        inputData.sellerInfo.input.countrySite.data === 5 ||
        inputData.sellerInfo.input.countrySite.data === 6 ||
        inputData.sellerInfo.input.countrySite.data === 8) && inputData.stockCost.input.xxts">
        <div v-if="inputData.stockCost.input.xxts.data === 0">
          <div style="border-top: 0.5px solid rgb(129, 129, 129)"></div>
          <div class="dialist">
            <div class="dialist-left">货物入口关税 (Import Duty):</div>
            <div class="dialist-right">
              ￥{{ triVistableType ? ITariff : (Number(ITariff) * Number(calcNum)).toFixed(2) }}
              <div class="dialist-right__txt">（物流双清包税）</div>
            </div>
          </div>
          <div class="dialist">
            <div class="dialist-left">货物入口销售增值税 (Import VAT):</div>
            <div class="dialist-right">
              ￥{{ triVistableType ? VAT : (Number(VAT) * Number(calcNum)).toFixed(2) }}
              <div class="dialist-right__txt">（物流双清包税）</div>
            </div>
          </div>
          <template v-if="triVistableType == 1">
            <div class="dialist">
              <div class="dialist-left">商品销售增值税(Sale VAT):</div>
              <div class="dialist-right">
                ￥{{ triVistableType ? spxszzs : (Number(spxszzs) * Number(calcNum)).toFixed(2) }}
                <div class="dialist-right__txt">（亚马逊代缴）</div>
              </div>
            </div>
            <div class="dialist">
              <div class="dialist-left">退税:</div>
              <div class="dialist-right" style="color:#fca605">
                -￥{{ triVistableType ?
                  (Math.abs(Number(VAT) - Number(spxszzs))).toFixed(2) :
                  (Math.abs(Number(VAT) - Number(spxszzs)) * Number(calcNum)).toFixed(2) }}
              </div>
            </div>
          </template>
          <div style="border: 1px dashed rgb(129, 129, 129)"></div>
          <div class="dialist">
            <div class="dialist-left">{{ triVistableType ? '入口国综合税费' : '货物入口税费' }}:</div>
            <div class="dialist-right">
              ￥{{ triVistableType ? rkgzhsf : (Number(rkgzhsf) * Number(calcNum)).toFixed(2) }}
              <!-- <div class="dialist-right__txt">（退税后实缴）</div> -->
            </div>
          </div>
        </div>
        <div v-else-if="inputData.stockCost.input.xxts.data === 1">
          <div style="border-top: 0.5px solid rgb(129, 129, 129)"></div>
          <div class="dialist">
            <div class="dialist-left">货物入口关税(Import Duty):</div>
            <div class="dialist-right">
              <div class="dialist-right--error">￥{{ triVistableType ? ITariff : (Number(ITariff) * Number(calcNum)).toFixed(2) }}</div>
              ￥0.00
              <div class="dialist-right__txt">（自缴）</div>
            </div>
          </div>
          <div class="dialist">
            <div class="dialist-left">货物入口销售增值税(Import VAT):</div>
            <div class="dialist-right">
              <div class="dialist-right--error">￥{{ triVistableType ? VAT : (Number(VAT) * Number(calcNum)).toFixed(2) }}</div>
              ￥0.00
              <div class="dialist-right__txt">（自缴）</div>
            </div>
          </div>
          <template v-if="triVistableType == 1">
            <div class="dialist">
              <div class="dialist-left">商品销售增值税(Sale VAT):</div>
              <div class="dialist-right">
                <div class="dialist-right">
                  ￥{{ triVistableType ? spxszzs : (Number(spxszzs) * Number(calcNum)).toFixed(2) }}
                  <div class="dialist-right__txt">（亚马逊代缴）</div>
                </div>
              </div>
            </div>
          </template>
          <div style="margin: 10px 0;line-height: 20px; font-size: 12px; color: #00a0c7;" class="dialist-right">(备注: 由于物流双清包税，“Import Duty”与Import VAT由物流公司支付，因此这两项税费可视为￥ 0.00)</div>
          <div style="border: 1px dashed rgb(129, 129, 129)"></div>
          <div class="dialist">
            <div class="dialist-left">{{ triVistableType ? '入口国综合税费' : '货物入口税费' }}:</div>
            <div class="dialist-right">
              ￥{{ triVistableType ? rkgzhsf : (Number(rkgzhsf) * Number(calcNum)).toFixed(2) }}
              <!-- <div class="dialist-right__txt">（亚马逊代缴）</div> -->
            </div>
          </div>
        </div>
      </template>
      <template v-else-if="inputData.sellerInfo.input.countrySite.data === 7 && inputData.stockCost.input.sqbs">
        <div v-if="inputData.stockCost.input.sqbs.data === 1">
          <div style="border-top: 0.5px solid rgb(129, 129, 129)"></div>
          <div class="dialist">
            <div class="dialist-left">货物入口关税(Import Duty):</div>
            <div class="dialist-right">
              ￥{{ triVistableType ? ITariff : (Number(ITariff) * Number(calcNum)).toFixed(2) }}
              <div class="dialist-right__txt">（自缴）</div>
            </div>
          </div>
          <div class="dialist">
            <div class="dialist-left">地方消费税:</div>
            <div class="dialist-right">
              ￥{{ triVistableType ? GST : (Number(GST) * Number(calcNum)).toFixed(2) }}
              <div class="dialist-right__txt">（自缴）</div>
            </div>
          </div>
          <div style="margin: 10px 0;line-height: 20px; font-size: 12px; color: #00a0c7;" class="dialist-right">(备注: 日本区别于欧盟，没有“Import VAT与“Sale VAT”，目前入口清关时需要预缴”商品入口关税 Import Duty”及预缴“地方消费税”)</div>
          <div style="border: 1px dashed rgb(129, 129, 129)"></div>
          <div class="dialist">
            <div class="dialist-left">{{ triVistableType ? '入口国综合税费' : '货物入口税费' }}:</div>
            <div class="dialist-right">￥{{ triVistableType ? rkgzhsf : (Number(rkgzhsf) * Number(calcNum)).toFixed(2) }}</div>
          </div>
        </div>
        <div v-else-if="inputData.stockCost.input.sqbs.data === 0">
          <div style="border-top: 0.5px solid rgb(129, 129, 129)"></div>
          <div class="dialist">
            <div class="dialist-left">货物入口关税(Import Duty):</div>
            <div class="dialist-right">
              <div class="dialist-right--error">￥{{ triVistableType ? ITariff : (Number(ITariff) * Number(calcNum)).toFixed(2) }}</div>
              ￥0.00
              <div class="dialist-right__txt">（物流双清包税）</div>
            </div>
          </div>
          <div class="dialist">
            <div class="dialist-left">地方消费税:</div>
            <div class="dialist-right">
              <div class="dialist-right--error">￥{{ triVistableType ? GST : (Number(GST) * Number(calcNum)).toFixed(2) }}</div>
              ￥0.00
              <div class="dialist-right__txt">（物流双清包税）</div>
            </div>
          </div>
          <div style="margin: 10px 0;line-height: 20px; font-size: 12px; color: #00a0c7;" class="dialist-right">(备注: 由于物流双清包税,以上两项税费由物流公司支付,因此这两项税费可视作为￥0.00; 另外日本区别于欧盟没有"Import VAT与"Sale VAT”)</div>
          <div style="border: 1px dashed rgb(129, 129, 129)"></div>
          <div class="dialist">
            <div class="dialist-left">{{ triVistableType ? '入口国综合税费' : '货物入口税费' }}:</div>
            <div class="dialist-right">￥{{ triVistableType ? rkgzhsf : (Number(rkgzhsf) * Number(calcNum)).toFixed(2) }}</div>
          </div>
        </div>
      </template>
      <template v-else-if="(inputData.sellerInfo.input.countrySite.data === 0 ||
        inputData.sellerInfo.input.countrySite.data === 1 ) && inputData.stockCost.input.sqbs">
        <div v-if="inputData.stockCost.input.sqbs.data === 1">
          <div style="border-top: 0.5px solid rgb(129, 129, 129)"></div>
          <div class="dialist">
            <div class="dialist-left">货物入口关税(Import Duty):</div>
            <div class="dialist-right">
              ￥{{ triVistableType ? ITariff : (Number(ITariff) * Number(calcNum)).toFixed(2) }}
              <div class="dialist-right__txt">（自缴）</div>
            </div>
          </div>
          <div style="margin: 10px 0;line-height: 20px; font-size: 12px; color: #00a0c7;" class="dialist-right">(备注: 美国区别于欧盟，没有"Import VAT"与"Sale VAT"，只需缴纳"Import Duty")</div>
          <div style="border: 1px dashed rgb(129, 129, 129)"></div>
          <div class="dialist">
            <div class="dialist-left">{{ triVistableType ? '入口国综合税费' : '货物入口税费' }}:</div>
            <div class="dialist-right">￥{{ triVistableType ? rkgzhsf : (Number(rkgzhsf) * Number(calcNum)).toFixed(2) }}</div>
          </div>
        </div>
        <div v-if="inputData.stockCost.input.sqbs.data === 0">
          <div style="border-top: 0.5px solid rgb(129, 129, 129)"></div>
          <div class="dialist">
            <div class="dialist-left">货物入口关税(Import Duty):</div>
            <div class="dialist-right">
              <div class="dialist-right--error">￥{{ triVistableType ? ITariff : (Number(ITariff) * Number(calcNum)).toFixed(2) }}</div>
              ￥0.00
              <div class="dialist-right__txt">（物流双清包税）</div>
            </div>
          </div>
          <div style="margin: 10px 0;line-height: 20px; font-size: 12px; color: #00a0c7;" class="dialist-right">(备注: 由于物流双清包税,“Import Duty”由物流公司支付，因此 这项税费可视为￥0.00另外，美国区别于欧盟，没有"Import VAT”与”Sale VAT")</div>
          <div style="border: 1px dashed rgb(129, 129, 129)"></div>
          <div class="dialist">
            <div class="dialist-left">{{ triVistableType ? '入口国综合税费' : '货物入口税费' }}:</div>
            <div class="dialist-right">￥{{ triVistableType ? rkgzhsf : (Number(rkgzhsf) * Number(calcNum)).toFixed(2) }}</div>
          </div>
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script>
  import Dialog from "@/components/common/Dialog";

  import {request} from "@/network/request";

  // 亚马逊站点
  let country_self = ['美国站','加拿大站','英国站','德国站','法国站','意大利站','西班牙站','日本站','澳洲站', '墨西哥站'];
  // 不需要货币标识
  let noneCurrency_self = ['','','','','','','','','',];
  // 默认货币
  let defaultCurrency_self = ['￥','￥','￥','￥','￥','￥','￥','￥','￥','￥'];
  // 国家货币
  let nationalCurrency_self = ['$','CA$','￡','€','€','€','$','JP￥','AU$','MX$'];
  // 英制 / 美制长度转换
  let lengthArray_self = ['(cm)', '(inch)'];
  // 英制 / 美制重量转换
  let weightArray_self = ['(kg)', '(lb)'];
  // 默认单位
  let defaultArray_self = ['', ''];

  export default {
    name: "calmDialog",
    components: {
      'my-dialog': Dialog
    },
    created() {
      // console.log(this.inputData.sellerInfo.input.sellerType.data)
      request({
        url: '/info/getExchangeRate',
        method: 'post',
        header: {
          'Content-Type': 'application/json'
        },
      }).then(res => {
        if(res.data.code === 1){
          this.USD_RMB = res.data.info.rates[0].rate
          for (let i = 0; i < 9; i ++){
            if(i === 3 || i === 4 || i === 5 || i === 6){
              this.Rate[i] = res.data.info.rates[3].rate
            }else if(i > 6){
              this.Rate[i] = res.data.info.rates[i - 3].rate
            }else
              this.Rate[i] = res.data.info.rates[i].rate
          }
        }
        // console.log(this.Rate)
      }).catch(err => {
        console.log(err)
      })
      request({
        url: '/product/getSales',
        method: 'post',
        header: {
          'Content-Type': 'application/json'
        },
        // data:{
        //   "countryArea": this.inputData.sellerInfo.input.countrySite.data === 0 || this.inputData.sellerInfo.input.countrySite.data === 1 ? 0 :
        //     this.inputData.sellerInfo.input.countrySite.data === 2 ? 1 :
        //     this.inputData.sellerInfo.input.countrySite.data === 3 || this.inputData.sellerInfo.input.countrySite.data === 4 ||
        //         this.inputData.sellerInfo.input.countrySite.data === 5 || this.inputData.sellerInfo.input.countrySite.data === 6 ? 2 :
        //     this.inputData.sellerInfo.input.countrySite.data === 7 ? 3 : 4,
        //   "productId": null
        // }
      }).then(res => {
        if(res.data.code === 1){
          this.Listing = res.data.info - this.calmNum
        }else{
          this.Listing = 0
        }
      }).catch(err => {
        console.log(err)
      })
    },
    beforeUpdate() {
      this.inputData = this.input;
      this.unitIndex = this.uIndex;
      if(this.inputData.sellerInfo.input.countrySite.data !== 0 && this.inputData.sellerInfo.input.countrySite.data !== 1
        && this.inputData.sellerInfo.input.countrySite.data !== 8 && this.inputData.sellerInfo.input.countrySite.data !== 7){
        this.isTariff = true
      }else {
        this.isTariff = false
      }
      // if(this.needUpdate){
      //   if(this.inputData.packData.input.long.data !== '' && this.inputData.packData.input.width.data !== '' && this.inputData.packData.input.weight.data !== ''
      //     && this.inputData.packData.input.height.data !== '' && this.inputData.sellerInfo.input.warehouseConfiguration.data !== ''
      //     && this.inputData.packData.input.sort.data !== ''){
      //     request({
      //       url: '/info/getAmazonLogisticsFee',
      //       method: 'post',
      //       header: {
      //         'Content-Type': 'application/json'
      //       },
      //       data: {
      //         "length": this.inputData.packData.input.long.data,
      //         "width": this.inputData.packData.input.width.data,
      //         "height": this.inputData.packData.input.height.data,
      //         "lengthType": this.unitIndex,
      //         "weight": this.inputData.packData.input.weight.data,
      //         "weightType": this.unitIndex,
      //         "productType": this.inputData.packData.input.sort.data,
      //         "countrySite": this.inputData.sellerInfo.input.countrySite.data,
      //         "mergeConfiguration": this.inputData.sellerInfo.input.warehouseConfiguration.data,
      //       }
      //     }).then(res => {
      //       if(res.data.code === 1){
      //         this.AWDCFee = (res.data.info.amazonMergeFee * this.Rate[0]).toFixed(2)
      //         this.warehouseCharges = (res.data.info.warehouseFee * this.Rate[0]).toFixed(2)
      //         this.ALShipping = (res.data.info.amazonLogisticsFee * this.Rate[0]).toFixed(2)
      //         this.warehouseFeeMonthly = res.data.info.warehouseFeeMonthly
      //       }
      //     })
      //   }
      // }
    },
    props: {
      dialogShow:{
        type: Boolean,
        default: false,
        required: true
      },
      input:{
        type: Object
      },
      uIndex:{
        type: Number
      },
      needUpdate: {
        type: Boolean
      },
      fatherVAT:{
        type: Number
      },
      // isChange:{
      //   type: Boolean,
      //   default: false
      // }
    },
    data(){
      return{
        // 显示loading 图标
      showLoadingIcon: false,
      showLoadingIcon1: false,
      triVistable:false,
      triVistableType: 0,
        // 计算类型
        calType: 1,
        text: '无合仓设置',
        // listing
        Listing: 0,
        // 分摊数据
        shareArray: ['0.0','0.5', '1.0', '1.5', '2.0', '2.5', '3.0', '3.5', '4.0', '4.5',
          '5.0', '5.5', '6.0', '6.5', '7.0', '7.5', '8.0', '8.5', '9.0', '9.5', '10.0'],
        // 增值税
        importVAT: -1,
        // 是否需要关税
        isTariff: true,
        // 是否需要登录
        isLogin: false,
        loginEmail: '',
        loginPassword: '',
        // 是否需要注册
        isRegister: false,
        // 是否可修改
        isChange: false,
        // 即时汇率
        Rate: [6.703045, 6.3, 6.3, 6.3, 6.3, 6.3, 6.3, 6.3, 6.3],
        RateName: ['USD', 'CAD', 'GBP', 'EUR', 'EUR', 'EUR', 'EUR', 'JPY', 'AUD'],
        // 会员会费
        membershipFee: [
          ['39.99','49.95','25.00','22.00','22.00','22.00','22.00','4900','49.95'],
          ['0','0','0','0','0','0','0','0','0']
        ],
        secondTitle: ['专业销售卖家账户月费', '个人销售卖家账户月费'],
        // 仓库收费
        warehouseCharges: 0,
        warehouseFeeMonthly: 12.00.toFixed(2),
        // 亚马逊站点
        country_self: ['美国站','加拿大站','英国站','德国站','法国站','意大利站','西班牙站','日本站','澳洲站', '墨西哥站'],
        // 不需要货币标识
        noneCurrency_self: ['','','','','','','','','',],
        // 默认货币
        defaultCurrency_self: ['￥','￥','￥','￥','￥','￥','￥','￥','￥','￥'],
        // 国家货币
        nationalCurrency_self: ['$','CA$','￡','€','€','€','$','JP￥','AU$','MX$'],
        // 英制 / 美制长度转换
        lengthArray_self: ['(cm)', '(inch)'],
        // 英制 / 美制重量转换
        weightArray_self: ['(kg)', '(lb)'],
        // 默认单位
        defaultArray_self: ['', ''],
        // 站点对应货币
        countryCurrency_self: ['美元','加元','英镑','欧元','欧元','欧元','欧元','日元','澳元', '比索'],
        // 当地运费
        ALShipping: 0,
        // 合仓配置费
        AWDCFee: 0,
        // 英美制进制索引
        unitIndex: 0,
        // 输入框数据
        inputData: {
          sellerInfo: {
            title: '站点及卖家账户信息',
            input: {
              countrySite: {
                name:'商品所属国家站点',
                type: 'select',
                unit: defaultArray_self,
                array: country_self,
                icon: noneCurrency_self,
                data: 0,
                detail: '',
                showDetail: false,
                isInput: true,
                isShow: true,
                isDisable: false,
              },
              sellerType: {
                name:'卖家账户类型',
                type: 'select',
                unit: defaultArray_self,
                array: ['专业销售计划', '个人销售计划'],
                icon: noneCurrency_self,
                data: '',
                detail: '<section data-role="outer" label="Powered by 135editor.com" style=""><section class="_135editor" data-role="paragraph"><p>亚马逊卖家分为“专业销售计划”及“个人销售计划”卖家。</p><p>(说明: 美国亚马逊“专业销售计划帐户”收费为每月$39.9，销售佣金另外计算；</p><p>美国亚马逊“个人销售计划帐户”收费为$0,但每套商品销售后收$0.99,销售佣金另外计算;</p><p>其它不同区域帐户收费类似）；</p><p><br></p><p>补充: 早前,亚马逊帐户分不同的区域帐户: 例如”北美区域帐户”包括美国,加拿大及墨西哥站点;</p><p>“欧盟区域帐户”包括德国，法国，西班牙，意大利站点; 英国脱欧后自成一”英国区域帐户;</p><p>日本与澳洲是另外两个独立的“日本区域帐户”及“澳洲区域帐户”，不同区域帐户各自收不同的卖家帐户月费；</p><p><br></p><p>但最近亚马逊实施了新政策, 对于“专业销售计划帐户”,所有不同的国家合并为1个卖家帐户,</p><p>统一只收$39.99月租费；但要注意的是,不同国家站点的帐户要合并设置后才能享受统一只收$39.99月租费；</p><p><br></p><p>“个人销售计划帐户”,收费保持不变；</p><p><br></p><p>备注：该项费用的分摊计算方法: 按整个卖家帐户的总销量来分摊到该商品上。</p><span>例如：该卖家帐户当月所有不同商品的总销量为100,那么该项费用将除以100计算该商品的分摊成本。</span></section></section>',
                showDetail: false,
                isInput: true,
                isShow: true,
                isDisable: false,
              },
              warehouseConfiguration: {
                name:'合仓设置',
                type: 'select',
                unit: defaultArray_self,
                array: ['已合仓', '未合仓'],
                icon: noneCurrency_self,
                data: '',
                detail: '<section data-role="outer" label="Powered by 135editor.com" style=""><p>当货物有N箱进行亚马逊FBA入仓计划时,亚马逊可能对该批货物安排进入N个不同仓库，</p><p>这样导致的结果是您将需要将该批货物分为N批次货物各自发运到不同的仓库地址,</p><p>国际物流运费成本及安排发运的操作成本自然地将大大增加。</p><p><br></p><p>为解决这个问题,亚马逊相应地提供”合仓配置“的功能,让该批货物可以合并发到同一个亚马逊仓库,</p><p>但同时亚马逊将针对“该批货物中的每一个商品收取”合仓配置费”。根据不同的商品分类,及其尺寸,</p><p>重量,类型等分为标准件,大件,超大件等收取不同的”合仓配置费”。</p><p><br></p><p>我们系统已根据您录入的商品信息,智能分析及计算出每套商品的”合仓配置费”,放请心使用。</p><p><br></p><p>温馨提示:每次发货的箱数不同,亚马逊将货物分配到多少个不同仓库难以确定,这个通常做了进仓计划后</p><p>才有确切数据。理论上卖家可根据两种情况下的“国际物流运费差”对比“该批货物被收取的总合仓配置费”</p><p>才能确认那个更划算。但实际上,合仓与不合仓设置得不断重设置,同时进仓计划要不停地放弃,这样会</p><p>影响亚马逊店铺的绩效分数。因此我们不建议合仓设置经常切换。当然,只有一两箱货物做进仓计划时</p><p>通常会安排到同一个仓库;视情况而定,对于不同的货物,卖家如果有时间可计算比较一下！</p><p><br></p><p>对于初级卖家,建议为了简单操作，设置为合仓为宜！</p></section>',
                showDetail: false,
                isInput: true,
                isShow: true,
                isDisable: true,
              },
              otherFee: {
                name: '独立网络等运营月费',
                type: 'number',
                unit: defaultArray_self,
                icon: defaultCurrency_self,
                data: '',
                detail: '<section data-role="outer" label="Powered by 135editor.com" style=""><p>根据卖家不同的运营方式及阶段,亚马逊卖家帐户“独立网络等运营月费”将包括: 独立IP网络的使用月费,</p><p>辅助运营软件月费及其它费用(如果不产生该项费用,可视费用为0)；</p><p><br></p><p>备注：该项费用的分摊计算方法与“卖家类型”的分摊方式一致:按整个卖家帐户的总销量来分摊到该商品上。</p><p>例如：该卖家帐户当月所有不同商品的总销量为100,那么该项费用将除以100计算该商品的分摊成本。</p></section>',
                showDetail: false,
                isInput: true,
                isShow: true,
                isDisable: false,
              },
              taxExpense: {
                name: '卖家帐户月均财务费',
                type: 'number',
                unit: defaultArray_self,
                icon: defaultCurrency_self,
                data: '',
                detail: '<section data-role="outer" label="Powered by 135editor.com" style=""><p>由于欧盟的税务要求非常严格,通常亚马逊卖家的商品入欧盟成员国及英国的亚马逊仓库并</p><p>进行销售时都需要申请注册当地公司(欧盟成员国及英国当地个人卖家在一定的年销售总额下例外)</p><p>并通过专业的会计师做帐,年审,报税等。因此每年产生一定的财务费用。按月平均分摊将产生该</p><p>“卖家帐户月均账务费”;</p><p><br></p><p>(备注:英国每3个月一次,1年共4次VAT申报; 意大利及西班牙每季节1次,年度1次,共5次VAT申报;</p><p>法国每月1次,1年共12次VAT申报;例如财务公司对英国帐户每年收取的做帐及VAT申报等财务费为</p><p>￥12000;即卖家帐户月均财务费为￥1000;</p><p><br></p><p>此项费用通常适用于英国及其它欧盟成员国; 美国,加拿大,日本,澳洲等国家通常不涉及此项费用;</p><p>但视实际情况而定,该项费用可按实际录入数据)；</p></section>',
                showDetail: false,
                isInput: true,
                isShow: true,
                isDisable: false,
                width: '540px'
              },
              operatingAnnualInterestRate: {
                name: '资金运营年息率',
                type: 'number',
                unit: defaultArray_self,
                icon: noneCurrency_self,
                data: '',
                detail: '<section data-role="outer" label="Powered by 135editor.com" style=""><p>该年息率用于计算亚马逊采购及物流等的资金运营成本。该项为预设值，请到“设置/店铺与帐户设置”目录页内进行预设置，对应数据才会在此自动导出。</p></section>',
                showDetail: false,
                isInput: true,
                isShow: true,
                isDisable: false,
                width:'510px'
              },
            }
          },
          packData:{
            title: '单个商品包装数据',
            input:{
              long: {
                name: '长',
                type: 'number',
                unit: lengthArray_self,
                icon: noneCurrency_self,
                data: '',
                detail: '',
                showDetail: false,
                isInput: true,
                isShow: true,
                isDisable: false,
              },
              width: {
                name: '宽',
                type: 'number',
                unit: lengthArray_self,
                icon: noneCurrency_self,
                data: '',
                detail: '',
                showDetail: false,
                isInput: true,
                isShow: true,
                isDisable: false,
              },
              height: {
                name: '高',
                type: 'number',
                unit: lengthArray_self,
                icon: noneCurrency_self,
                data: '',
                detail: '',
                showDetail: false,
                isInput: true,
                isShow: true,
                isDisable: false,
              },
              weight:{
                name: '重量',
                type: 'number',
                unit: weightArray_self,
                icon: noneCurrency_self,
                data: '',
                detail: '',
                showDetail: false,
                isInput: true,
                isShow: true,
                isDisable: false,
              },
              sort: {
                name: '商品分类',
                type: 'select',
                unit: defaultArray_self,
                array: ['非服装,鞋靴，箱包分类', '服装，鞋靴，箱包分类'],
                icon: noneCurrency_self,
                data: '',
                detail: '',
                showDetail: false,
                isInput: true,
                isShow: true,
                isDisable: false,
              },

              unit: {
                name: '计价单位',
                type: 'select',
                unit: defaultArray_self,
                array: ['套', '个', '盒', '包', '袋', '支'],
                icon: noneCurrency_self,
                data: '',
                detail: '',
                showDetail: false,
                isInput: true,
                isShow: true,
                isDisable: false,
              },
            }
          },
          stockCost: {
            title: '商品采购及物流成本',
            input: {
              xxts:{
                name: '销售退税',
                type: 'select',
                unit: defaultArray_self,
                array:['是','否'],
                icon: noneCurrency_self,
                data: 1,
                detail: '<section data-role="outer" label="Powered by 135editor.com" style=""><p><span style="caret-color: red;">指“基于以上采购数量”的该批商品的国际物流费；</span><br></p><p>备注:如果同批货物里有多款不同商品,可根据实际情况按该批商品对整批货物的体积或重量占比分摊运费。</p></section>',
                showDetail: false,
                isInput: true,
                isShow: true,
                isDisable: true,
              },
              sqbs:{
                name: '双清包税',
                type: 'select',
                array:['是','否'],
                unit: defaultArray_self,
                icon: noneCurrency_self,
                data: 0,
                detail: '<section data-role="outer" label="Powered by 135editor.com" style=""><p><span style="caret-color: red;">指“基于以上采购数量”的该批商品的国际物流费；</span><br></p><p>备注:如果同批货物里有多款不同商品,可根据实际情况按该批商品对整批货物的体积或重量占比分摊运费。</p></section>',
                showDetail: false,
                isInput: true,
                isShow: true,
                isDisable: false,
              },
              stockPrice: {
                name: '采购单价',
                type: 'number',
                unit: ['(/套)', '(/个)', '(/盒)', '(/包)', '(/袋)', '(/支)'],
                icon: defaultCurrency_self,
                data: '',
                detail:'对于贸易公司或个人，这里就是产品的采购单价；；对于生产厂家，这里可以理解为产品的出厂单价；',
                showDetail: false,
                isInput: true,
                isShow: true,
                isDisable: false,
              },
              stockNum: {
                name: '采购数量',
                type: 'number',
                unit: ['(套)', '(个)', '(盒)', '(包)', '(袋)', '(支)'],
                icon: noneCurrency_self,
                data: '',
                detail:'对于贸易公司或个人，这里就是产品的采购数量；；对于生产厂家，这里可以理解为产品的生产数量；',
                showDetail: false,
                isInput: true,
                isShow: true,
                isDisable: false,
              },
              domesticFreight: {
                name: '国内总运费',
                type: 'number',
                unit: defaultArray_self,
                icon: defaultCurrency_self,
                data: '',
                detail: '<section data-role="outer" label="Powered by 135editor.com" style=""><p>指基于以上采购数量,该批商品自己安排发货而产生的国内段运费; 如果国际货运公司免费上门收件,</p><p>该国内总运费可视为0,在单元格数据可输入0即可；</p><p><br></p><p>备注:如果同批货物里有多款不同商品,可根据实际情况按该批商品对整批货物的体积或重量占比分摊运费。</p></section>',
                showDetail: false,
                isInput: true,
                isShow: true,
                isDisable: false,
              },
              internationFreight: {
                name: '国际总运费',
                type: 'number',
                unit: defaultArray_self,
                icon: defaultCurrency_self,
                data: '',
                detail: '<section data-role="outer" label="Powered by 135editor.com" style=""><p><span style="caret-color: red;">指“基于以上采购数量”的该批商品的国际物流费；</span><br></p><p>备注:如果同批货物里有多款不同商品,可根据实际情况按该批商品对整批货物的体积或重量占比分摊运费。</p></section>',
                showDetail: false,
                isInput: true,
                isShow: true,
                isDisable: false,
              },
              saleTax: {
                name: '海关申报单价',
                type: 'number',
                unit: ['(/套)', '(/个)', '(/盒)', '(/包)', '(/袋)', '(/支)'],
                icon: defaultCurrency_self,
                data: '',
                detail: '海关申报单价主要用于目的港清关,根据货物申报价值计算目的国入口关税等;',
                showDetail: false,
                isInput: true,
                isShow: true,
                isDisable: true,
                width:'420px'
              },
              sprkgsl: {
                name: '商品入口关税率',
                type: 'number',
                unit: defaultArray_self,
                icon: noneCurrency_self,
                data: '',
                detail: '',
                showDetail: false,
                isInput: true,
                isShow: true,
                isDisable: false,
              },
              importTariff: {
                name: '货物入口税费',
                type: 'number',
                unit: defaultArray_self,
                icon: defaultCurrency_self,
                data: '',
                detail: '<section data-role="outer" label="Powered by 135editor.com" style=""><p>由于商品的多样性及复杂性,即使出口国对该商品归类为某对应的商品海关编码(HS CODE),</p><p>但终究以进口国对该进口商品进行审核及判断商品的归类及价值为准。因此商品入口关税</p><p>是不确定的,不能准确计算。</p><p><br></p><p>通常由国际物流公司在目的港清关时为该批商品支付了的关税,然后按实报实销原则向货主收取</p><p>(卖家按实收金额数值输入到单元格即可）。对于DDP双清包税的物流渠道,由于已包含清关关税,</p><p>这种情况下可以在单元格内输入0。</p></section>',
                showDetail: false,
                isInput: true,
                isShow: true,
                isDisable: false,
                width:'520px'
              }
            }
          },
          operatingExpenses: {
            title: '商品当月运营费用',
            input: {
              advertisingFee: {
                name: '当月站内广告费',
                type: 'number',
                unit: defaultArray_self,
                icon: nationalCurrency_self,
                data: '',
                detail: '<section data-role="outer" label="Powered by 135editor.com" style=""><p>指“该商品当月的”亚马逊站内的点击广告费”;可在亚马逊后台“广告管理”内查询该商品的当月点击</p><p>广告费用。如不涉及这项费用,在单元格数据可以输入0；</p></section>',
                showDetail: false,
                isInput: true,
                isShow: true,
                isDisable: false,
              },
              dealFee: {
                name: '当月站内Deal费用',
                type: 'number',
                unit: defaultArray_self,
                icon: nationalCurrency_self,
                data: '0',
                detail: '',
                showDetail: false,
                isInput: true,
                isShow: false,
                isDisable: false,
              },
              couponFee: {
                name: '当月站内Coupon费用',
                type: 'number',
                unit: defaultArray_self,
                icon: nationalCurrency_self,
                data: '0',
                detail: '',
                showDetail: false,
                isInput: true,
                isShow: false,
                isDisable: false,
              },
              billingFee: {
                name: '当月站外测评费',
                type: 'number',
                unit: defaultArray_self,
                icon: defaultCurrency_self,
                data: '',
                detail: '<section data-role="outer" label="Powered by 135editor.com" style=""><p>指该商品当月亚马逊站外的“测评实际损耗”(此测评基于商品免费提供及不回收的情况）。</p><p><br></p><p>“当月站外测评费”的参考计算公式：</p><p>当月站外测评费 = （该商品的采购成本 + 国内单位运费 + 国际单位运费 +</p><p>合仓配置费 + 当地运费 + 亚马逊佣金 + 测评服务费）* 该商品的测试数量；</p><p><br></p><p>如果商品有其它不同的测评方式，例如：不同的留评比率或可回收商品等,请根据您的实际情况</p><p>输入相应的当月站外测评费);如不涉及这项提成,可以输入0；</p></section>',
                showDetail: false,
                isInput: true,
                isShow: true,
                isDisable: false,
                width:'510px'
              },
              drainageFee: {
                name: '当月站外引流费',
                type: 'number',
                unit: defaultArray_self,
                icon: defaultCurrency_self,
                data: '',
                detail: '<section data-role="outer" label="Powered by 135editor.com" style=""><p>指由亚马逊站外的渠道推广引流的月费，例如通过Facebook, Google或其它网站的点击广告或</p><p>其它运营操作引流到该亚马逊在售商品所产生的费用;如不涉及这项费用,可以输入0；</p></section>',
                showDetail: false,
                isInput: true,
                isShow: true,
                isDisable: false,
                width:'510px'
              },
              salesCommission: {
                name: '商品销售提成率',
                type: 'number',
                array: ['0.0%','0.5%', '1.0%', '1.5%', '2.0%', '2.5%', '3.0%', '3.5%', '4.0%', '4.5%',
                  '5.0%', '5.5%', '6.0%', '6.5%', '7.0%', '7.5%', '8.0%', '8.5%', '9.0%', '9.5%', '10.0%'],
                unit: defaultArray_self,
                icon: noneCurrency_self,
                data: '',
                detail: '<section data-role="outer" label="Powered by 135editor.com" style=""><p>指基于"商品售价"的销售提成率（此项是为店铺销售人员设置的对于当前商品的销售提成率；此项为预设置项，如要修改，请先到“设置/商品销售提成设置”目录页对应修改更新);</p></section>',
                showDetail: false,
                isInput: true,
                isShow: true,
                isDisable: true,
                width:'510px'
              },
              operationCommission: {
                name: '运营管理提成率',
                type: 'number',
                array: ['0.0%','0.5%', '1.0%', '1.5%', '2.0%', '2.5%', '3.0%', '3.5%', '4.0%', '4.5%',
                  '5.0%', '5.5%', '6.0%', '6.5%', '7.0%', '7.5%', '8.0%', '8.5%', '9.0%', '9.5%', '10.0%'],
                unit: defaultArray_self,
                icon: noneCurrency_self,
                data: '',
                detail: '<section data-role="outer" label="Powered by 135editor.com" style=""><p>指也是基于“商品售价”的运营管理提成率（此项是为“亚马逊多店铺运营管理人员”设置的针对“所有店铺商品”“统一的销售提成率”；如您的亚马逊销售体量较大，已涉及运营管理人员，或者您的亚马逊是通过代运营管理，可以考虑设置该项提成；此项为预设置项，如要修改，请先到“设置/店铺及费用设置”目录页对应修改更新);</p></section>',
                showDetail: false,
                isInput: true,
                isShow: true,
                isDisable: true,
                width:'510px'
              },
              commission: {
                name: '亚马逊销售佣金率',
                type: 'number',
                unit: defaultArray_self,
                icon: noneCurrency_self,
                data: '',
                detail: '<section data-role="outer" label="Powered by 135editor.com" style=""><p>指亚马逊对商品抽取的“销售佣金率”（此项为预设置项，如要修改，请先到“销售/Listing管理”目录页查找对应商品信息进行“商品销售佣金率”的修改更新);</p></section>',
                showDetail: false,
                isInput: true,
                isShow: true,
                isDisable: true,
              },
              recoveryLossRate: {
                name: '收汇损失率',
                type: 'number',
                unit: defaultArray_self,
                icon: noneCurrency_self,
                data: '',
                detail: '<section data-role="outer" label="Powered by 135editor.com" style=""><p>该收汇损失率可根据您所合作的收汇公司实际收取的服务费率设置 (该项为预设值，请到“设置/店铺运营管理提成设置”目录页内进行预设置，对应数据才会在此自动导出)。</p></section>',
                showDetail: false,
                isInput: true,
                isShow: true,
                isDisable: true,
                width:'480px'
              },
            }
          },
          productRevenue: {
            title: '商品售价,销量,退货量,仓储,汇损',
            input: {
              sellingPrice: {
                name: '商品售价',
                type: 'number',
                unit: ['(/套)', '(/个)', '(/盒)', '(/包)', '(/袋)', '(/支)'],
                icon: nationalCurrency_self,
                data: 0,
                detail: '',
                showDetail: false,
                isInput: true,
                isShow: true,
                isDisable: true,
              },
              showSales: {
                name: '当月显示销量',
                type: 'number',
                unit: ['(套)', '(个)', '(盒)', '(包)', '(袋)', '(支)'],
                icon: noneCurrency_self,
                data: '',
                detail: '<section data-role="outer" label="Powered by 135editor.com" style=""><p>可根据这个路径:“亚马逊后台/数据报告/业务报告/根据ASIN及日期筛选及查询显示的销售量”</p><p><br></p><p>注意:</p><p style="margin-left:0;text-indent:0">1. 商品销售量与订单量不同,1个订单可能有N个商品；</p><p style="margin-left:0;text-indent:0">2. 在显示商品Listing销售量的页面,有些订单是坏品弃置的记录单,注意辨识及减除；</p><p><br></p><p>我们系统内还有另外一项“当月实际销量”，当月实际销量 = 当月销量 - 当月坏品退货数 - 当月非坏品退货数</p></section>',
                showDetail: false,
                isInput: true,
                isShow: true,
                isDisable: false,
                width:'500px'
              },
              disposalNum: {
                name: '当月坏品退货数',
                type: 'number',
                unit: ['(套)', '(个)', '(盒)', '(包)', '(袋)', '(支)'],
                icon: noneCurrency_self,
                data: '',
                detail: '<section data-role="outer" label="Powered by 135editor.com" style=""><p>坏品退货数查询路径：</p><p style="margin-left:0;text-indent:0">1. 亚马逊后台 / 库存 / 管理亚马逊库存 / 库存控制面板 / 管理亚马逊物流退货; 或</p><p style="margin-left:0;text-indent:0">2. 亚马逊后台 / 数据报告 / 退货报告 / 查看亚马逊物流报告 / 亚马逊物流买家退货;</p><p><br></p><p>通过对应的国家,ASIN及“最近30日”筛选出相应的商品及统计“库存属性”为“Customer Damaged买家导致的残损”及“Defective存在瑕疵”的坏品的总退货数量,在单元格输入即可)；&nbsp;</p><p><br></p><p>(备注:商品退回亚马逊仓库后亚马逊会对商品进行检查及进行“库存属性”的定性。当定性为“买家导致的残损”及“存在瑕疵”,商品将在一定天数后才安排坏品弃置。</p><p><br></p><p>补充:</p><p>1套“库存属性”定性为“买家导致的残损”及“存在瑕疵”的坏品退货的实际损失 =</p><p>商品的采购成本 + 国内运费 + 国际运费 + 合仓配置费 + 仓储成本 + 亚马逊卖家帐户月费分摊 +</p><p>月广告费用分摊 + 月测试费用分摊 + 站外月引流费用分摊 + 当地运费+亚马逊佣金；</p></section>',
                showDetail: false,
                isInput: true,
                isShow: true,
                isDisable: false,
              },
              returnNum: {
                name: '当月非坏品退货数',
                type: 'number',
                unit: ['(套)', '(个)', '(盒)', '(包)', '(袋)', '(支)'],
                icon: noneCurrency_self,
                data: 0,
                detail: '<section data-role="outer" label="Powered by 135editor.com" style=""><p>非坏品退货数查询路径:</p><p style="margin-left:0;text-indent:0">1. 亚马逊后台 / 库存 / 管理亚马逊库存 / 库存控制面板/管理亚马逊物流退货; 或</p><p style="margin-left:0;text-indent:0">2. 亚马逊后台 / 数据报告 / 退货报告 / 查看亚马逊物流报告 / 亚马逊物流买家退货;</p><p><br></p><p>通过对应的国家,ASIN及“最近30日”筛选出相应的商品及统计“库存属性”为“Sellable可售”的非坏品的总退货数量,</p><p>在单元格输入即可)；</p><p><br></p><p>(备注:商品退回亚马逊仓库后亚马逊会对商品进行检查及进行“库存属性”的定性。当定性为“Sellable可售”,</p><p>商品将会被亚马逊重新安排上架及作为Used二手货物降价,以跟卖的方式销售。</p><p><br></p><p>补充：</p><p>1套“Sellable可售”的非坏品退货的实际损失 =</p><p>该商品售价的亚马逊销售佣金部分的20% + 当地运费 + 25% &nbsp;* 商品售价 * （1 - 亚马逊佣金率)；</p><p>(备注：此项计算基于粗略假设亚马逊将商品降价25%重新上架销售)</p></section>',
                showDetail: false,
                isInput: true,
                isShow: false,
                isDisable: false,
              },
              dyqzycsl: {
                name: '当月弃置移除数量',
                type: 'number',
                unit: ['(套)', '(个)', '(盒)', '(包)', '(袋)', '(支)'],
                icon: noneCurrency_self,
                data: '',
                detail: '<section data-role="outer" class="article135" label="edit by 135editor"><p>备注：由于亚马逊的区域移除报告不提供对应的国家站点数据，该单元格取值按“区域移除数据报告”对应的的这个ASIN的移除数量除以“该区域已开通的国家站点的数量”；数据默认进位为整数；</p><section class="_135editor" data-role="paragraph"><p><br></p></section></section>',
                showDetail: false,
                isInput: true,
                isShow: true,
                isDisable: false,
              },

              positionDay: {
                name: '商品当前库存量',
                type: 'number',
                unit: ['(套)', '(个)', '(盒)', '(包)', '(袋)', '(支)'],
                icon: noneCurrency_self,
                data: '',
                detail: '<section data-role="outer" label="Powered by 135editor.com" style=""><p>根据这个链接: <a href="https://sellercentral.amazon.com/inventory">https://sellercentral.amazon.com/inventory</a>;</p><p>或根据这个路径: 亚马逊后台 / 库存 / 对应商品的ASIN查询该商品的当前库存数量即可。</p></section>',
                showDetail: false,
                isInput: true,
                isShow: true,
                isDisable: false,
                width:'480px'
              },
              dybpcsl: {
                name: '当月赔偿回款',
                type: 'number',
                unit: [],
                icon: nationalCurrency_self,
                data: '',
                detail: '',
                showDetail: false,
                isInput: true,
                isShow: true,
                isDisable: false,
              },
              // commission: {
              //   name: '亚马逊销售佣金率',
              //   type: 'number',
              //   unit: defaultArray_self,
              //   icon: noneCurrency_self,
              //   data: '',
              //   detail: '<section data-role="outer" label="Powered by 135editor.com" style=""><p>指亚马逊对该商品收取的销售佣金率。根据路径: “亚马逊后台销售中心/库存/库存管理”目录页查找对应的商品Listing的“销售佣金”,再用“销售佣金”除以“商品售价”就可得出“销售佣金率”，然后输入到本单元格即可。</p><p><br></p><p>(补充: 1.通常,商品的佣金率很少变化，一旦确定，卖家在商品以后的销售运营过程中修改商品售价时将不影响本系统自动计算实际佣金额，这样将有利于系统准确计算商品及店铺利润。2.对于还没有在亚马逊后台创建商品Listing的选品阶段, 卖家可在后台查询亚马逊类目及对应的佣金率,输入到本单元格即可快速进行商品预算)</p></section>',
              //   showDetail: false,
              //   isInput: true,
              //   isShow: true,
              //   isDisable: false,
              // },

            }
          },
        },
        isAble: true,
        // 登录名
        loginName: '',
        // 登录密码
        password: '',
        // 确定密码
        againPassword: '',
        // 手机号码
        phone: '',
        // 验证码
        verity: '',
        loginVerity:'',
        // 验证码图片
        imgSrc: '/api/register/getVerity',
        loginImgSrc:'/api/login/getVerity',
        // 是否需要获取手机短信
        showPhone: false,
        // 倒计时
        time: 0,
        timer: null,
        // 手机短信
        phoneVerity: '',
        phoneCode:'',
        doubleLogin:false,
        isSendPhone: false,
        time2: 0,
        timer2: null,
        // 手机区号标识
        phoneName: '+86 ',
        show1: false,
        show2: false,
        show3: false,
        // 显示细节弹窗
        showDetailCalm: [false, false, false, false, false, false, false, false, false, false, false, false]
      }
    },
    watch:{
      dateRange(){
         if(this.inputData.packData.input.long.data !== '' && this.inputData.packData.input.width.data !== '' && this.inputData.packData.input.weight.data !== ''
          && this.inputData.packData.input.height.data !== '' && this.inputData.sellerInfo.input.warehouseConfiguration.data !== ''
          && this.inputData.packData.input.sort.data !== ''){
          request({
            url: '/info/getAmazonLogisticsFee',
            method: 'post',
            header: {
              'Content-Type': 'application/json'
            },
            data: {
              "length": this.inputData.packData.input.long.data,
              "width": this.inputData.packData.input.width.data,
              "height": this.inputData.packData.input.height.data,
              "lengthType": this.unitIndex,
              "weight": this.inputData.packData.input.weight.data,
              "weightType": this.unitIndex,
              "productType": this.inputData.packData.input.sort.data,
              "countrySite": this.inputData.sellerInfo.input.countrySite.data,
              "mergeConfiguration": this.inputData.sellerInfo.input.warehouseConfiguration.data,
            }
          }).then(res => {
            if(res.data.code === 1){
              this.AWDCFee = (res.data.info.amazonMergeFee * this.Rate[0]).toFixed(2)
              this.warehouseCharges = (res.data.info.warehouseFee * this.Rate[0]).toFixed(2)
              this.ALShipping = (res.data.info.amazonLogisticsFee * this.Rate[0]).toFixed(2)
              this.warehouseFeeMonthly = res.data.info.warehouseFeeMonthly
            }
          })
        }
      },
      "inputData.sellerInfo.input.countrySite.data":{
        handler(newVal){
          let arr = [0, 1, 7, 9]
          if(arr.includes(newVal)){
            // this.inputData.stockCost.input.xxts.isDisable = true
            this.inputData.stockCost.input.sqbs.isDisable = false
            this.inputData.stockCost.input.importTariff.isDisable = false
          }else{
            // this.inputData.stockCost.input.xxts.isDisable = false
            this.inputData.stockCost.input.sqbs.isDisable = true
            this.inputData.stockCost.input.importTariff.data = 0
            this.inputData.stockCost.input.importTariff.isDisable = true
          }
        },
        immediate: true
      },
      "inputData.stockCost.input.sqbs.data":{
        handler(newVal){
          if(!newVal){
            this.inputData.stockCost.input.importTariff.data = 0
            this.inputData.stockCost.input.importTariff.isDisable = true
          }else{
            this.inputData.stockCost.input.importTariff.isDisable = false
          }
        },
        immediate: true
      },
    },
    computed: {
      // 入口国综合税费
    rkgzhsf(){
      let arr1 = [2, 3, 4, 5, 6, 8]
      let arr2 = [0, 1, 9]
      if(arr1.includes(this.inputData.sellerInfo.input.countrySite.data)){
        if(this.inputData.stockCost.input.xxts.data == 0){
          return (2 * Number(this.VAT) + Number(this.ITariff)).toFixed(2)
        }else{
          return this.spxszzs
        }
      }else if(arr2.includes(this.inputData.sellerInfo.input.countrySite.data)){
        if(this.inputData.stockCost.input.sqbs.data == 0){
          return '0.00'
        }
        return this.ITariff
      }else{
        if(this.inputData.stockCost.input.sqbs.data == 0){
          return '0.00'
        }
        return (Number(this.GST) + Number(this.ITariff)).toFixed(2)
      }
    },
    // 商品销售增值税
    spxszzs(){
      let num = parseFloat(this.Rate[this.inputData.sellerInfo.input.countrySite.data]) * Number(this.inputData.productRevenue.input.sellingPrice.data)
         * 20 / 100
      return num.toFixed(2)
    },
    // 赔偿回款分摊
    pchkft(){
      return (Number(this.inputData.productRevenue.input.dybpcsl.data) * parseFloat(this.Rate[this.inputData.sellerInfo.input.countrySite.data]) / this.calmNum).toFixed(2)
    },
    // 坏品弃置移除费用分摊
    discardPrice(){
      let w= Number(this.inputData.packData.input.weight.data)
      let y = 0
      if( w > 0 && w <= 0.5 ){
          y = 0.97
      }
      if( w > 0.5 && w <= 1){
        y = 1.46
      }
      if( w > 1 && w <= 2 ){
        y = 2.2
      }
      // case( w === )
      if( w > 2 ){
        y = (2.83 + 1.06 * ( w - 2)).toFixed(2)
      }
      return (y * parseFloat(this.Rate[this.inputData.sellerInfo.input.countrySite.data]) * Number(this.inputData.productRevenue.input.dyqzycsl.data) / this.calmNum).toFixed(2)

    },
      dateRange(){
        return {
          "length": this.inputData.packData.input.long.data,
          "width": this.inputData.packData.input.width.data,
          "height": this.inputData.packData.input.height.data,
          "lengthType": this.unitIndex,
          "weight": this.inputData.packData.input.weight.data,
          "weightType": this.unitIndex,
          "productType": this.inputData.packData.input.sort.data,
          "countrySite": this.inputData.sellerInfo.input.countrySite.data,
          "mergeConfiguration": this.inputData.sellerInfo.input.warehouseConfiguration.data,
          }
      },
      // dateRange() {
      //   // let start = this.inputData;
      //   return {start, end}
      // },
      listing(){
        let num = this.Listing + this.calmNum
        if(num <= 0){
          return 1
        }else{
          return num
        }
        // if(this.Listing === 0){
        //   return 0
        // }
        // let num = this.Listing + this.calmNum
        // return num
      },
      // 计算用实际销量
      calmNum(){
        if(this.ASales >= 1){
          return this.ASales
        }else{
          return 1
        }
      },
      // 计算用显示销量
      calcNum(){
        if(this.inputData.productRevenue.input.showSales.data >= 1){
          return this.inputData.productRevenue.input.showSales.data
        }else{
          return 1
        }
      },
      // 商品入口关税
      GST(){
        if(this.inputData.productRevenue.input.sellingPrice.data === ''){
        return '0.00'
      }
      let num = parseFloat(this.inputData.productRevenue.input.sellingPrice.data) * parseFloat(this.Rate[this.inputData.sellerInfo.input.countrySite.data]) / (1 + 0.078) * 0.078
      num = Math.round(num * 100) / 100
      return num.toFixed(2)
      },
      // 资金运营利润成本
      OPCost(){
      if( parseInt(this.inputData.productRevenue.input.returnNum.data) === 0
        || parseInt(this.inputData.productRevenue.input.disposalNum.data) === 0 || !this.inputData.sellerInfo.input.operatingAnnualInterestRate.data
        || this.inputData.productRevenue.input.positionDay.data === ''){
        return '0.00'
      }
      // let num = (parseFloat(this.IUFreight) + parseFloat(this.DUFreight) + parseFloat(this.PPCost) ) * parseInt('3') *
      //   parseFloat(this.inputData.sellerInfo.input.operatingAnnualInterestRate.data) / 12  / 100
      let num = (parseFloat(this.IUFreight) + parseFloat(this.DUFreight) + parseFloat(this.PPCost) + parseFloat(this.ITariff)) * parseInt('2') *
        (parseInt(this.inputData.productRevenue.input.showSales.data) + parseInt(this.inputData.productRevenue.input.positionDay.data)) *
        parseFloat(this.inputData.sellerInfo.input.operatingAnnualInterestRate.data) / 12  / 100 / this.calcNum
      num = Math.round(num * 100) / 100
      return num.toFixed(2)
    },
      // 商品入口关税
      ITariff(){
        if(!this.calmNum || !this.inputData.stockCost.input.saleTax.data){
        return '0.00'
      }
      let num = parseFloat(this.inputData.stockCost.input.saleTax.data) / 100 * 2.8
      num = Math.round(num * 100) / 100
      return num.toFixed(2)
      },
      // 商品入口增值税
      CIVTax(){
        if(this.ITariff !== this.ITariff || !this.inputData.stockCost.input.saleTax.data || !this.IUFreight
          || this.inputData.sellerInfo.input.countrySite.data === 7 || this.inputData.sellerInfo.input.countrySite.data === 8){
          return '0.00'
        }
        let num
        if(this.importVAT === -1){
          num = (parseFloat(this.ITariff) + parseFloat(this.inputData.stockCost.input.saleTax.data) + parseFloat(this.IUFreight)) * parseFloat(this.fatherVAT)
        }else {
          num = (parseFloat(this.ITariff) + parseFloat(this.inputData.stockCost.input.saleTax.data) + parseFloat(this.IUFreight)) * parseFloat(this.importVAT)
        }
        num = Math.round(num * 100) / 100
        return num.toFixed(2)
      },
      // 商品销售VAT
      VAT(){
        if(this.CIVTax !== this.CIVTax || !this.PRevenue || this.inputData.sellerInfo.input.countrySite.data === 7 || this.inputData.sellerInfo.input.countrySite.data === 8){
          return '0.00'
        }
        let num
        if(this.importVAT === -1){
          num = parseFloat(this.inputData.productRevenue.input.sellingPrice.data) * parseFloat(this.Rate[this.inputData.sellerInfo.input.countrySite.data])* parseFloat(this.fatherVAT) - parseFloat(this.CIVTax)
          // num = parseFloat(this.PRevenue) * parseFloat(this.fatherVAT) - parseFloat(this.CIVTax)
        }else {
          num = parseFloat(this.inputData.productRevenue.input.sellingPrice.data) * parseFloat(this.Rate[this.inputData.sellerInfo.input.countrySite.data])* parseFloat(this.importVAT) - parseFloat(this.CIVTax)
          // num = parseFloat(this.PRevenue) * parseFloat(this.importVAT) - parseFloat(this.CIVTax)
        }
        num = Math.round(num * 100) / 100
        return num.toFixed(2)
      },
      // 财务税务费用分摊
      FTESharing(){
        if(!this.inputData.sellerInfo.input.taxExpense.data || this.calType == 1){
          return '0.00'
        }
        if(this.calType == 0){
          let num = parseFloat(this.inputData.sellerInfo.input.taxExpense.data) / this.calmNum
          num = Math.round(num * 100) / 100
          return num.toFixed(2)
        }else {
          let num = parseFloat(this.inputData.sellerInfo.input.taxExpense.data) / parseFloat(this.listing)
          num = Math.round(num * 100) / 100
          return num.toFixed(2)
        }
      },
      // 商品当月实际总净利润
      ATGPOTPFTMonth(){
        if(this.ASales === 0 || this.PGProfit === 0){
          return 0;
        }
        let num = this.calmNum * this.PGProfit;
        num = Math.round(parseFloat(num) * 10) / 10
        return num.toFixed(1);
      },
      // 商品当月实际总收款
      TATCOPITMonth(){
        if(this.ASales === 0 || this.APReceipt === 0){
          return 0;
        }
        let num = this.ASales * this.APReceipt;
        num = Math.round(parseFloat(num))
        return num;
      },
      // 商品当月总销售额
      TMPSales(){
        if(this.PRevenue === 0 || !this.inputData.productRevenue.input.showSales.data){
          return 0
        }
        let num = this.PRevenue * this.inputData.productRevenue.input.showSales.data;
        num = Math.round(parseFloat(num))
        return num;
      },
      // 商品出资成本
      CostCapital(){
        // 入口关税  + 采购单价 + 国内单位运费 + 国际单位运费 + 月测评费用分摊 + 站外月引流费用分摊 + 独立网络等运营月费分摊 + 卖家帐户月费分摊
        let num = parseFloat(this.ITariff)  + parseFloat(this.PPCost) + parseFloat(this.DUFreight) + parseFloat(this.IUFreight) + parseFloat(this.AOMFees) +parseFloat( this.OMDCSharing) + parseFloat(this.AOSMFAllocation) + parseFloat(this.FTESharing)
        // let num = this.ITariff + this.PPCost + this.DUFreight + this.IUFreight + this.MACSharing + this.AOMFees + this.OMDCSharing + this.AOSMFAllocation + this.FTESharing
        num = Math.round(parseFloat(num) * 10) / 10
        return num.toFixed(1)
      },
      // 商品实际收款
      APReceipt(){
        let num = (this.PRevenue - this.ACommission - this.ALShipping - this.MACSharing
          - this.BPLAllocation - this.RLAllocation - this.WCSharing - this.AWDCFee - this.PSMAllocation - this.FELoss);
        if(num <= 0){
          return '0.0'
        }
        num = Math.round(parseFloat(num) * 10) / 10
        return num.toFixed(1);
      },
      // 商品采购成本
      PPCost(){
        if(this.inputData.stockCost.input.stockPrice.data === '' || this.inputData.stockCost.input.stockPrice.data === 0){
          return '0.00';
        }
        let num = this.inputData.stockCost.input.stockPrice.data;
        num = Math.round(parseFloat(num) * 100) / 100
        return num.toFixed(2);
      },
      // 国内单位运费
      DUFreight(){
        if(!this.inputData.stockCost.input.domesticFreight.data || !this.inputData.stockCost.input.stockNum.data){
          return '0.00'
        }
        let num = parseFloat(this.inputData.stockCost.input.domesticFreight.data) / parseFloat(this.inputData.stockCost.input.stockNum.data);
        num = Math.round(num * 100) / 100
        return num.toFixed(2);
      },
      // 国际单位运费
      IUFreight(){
        if(!this.inputData.stockCost.input.internationFreight.data || !this.inputData.stockCost.input.stockNum.data){
          return '0.00'
        }
        let num = parseFloat(this.inputData.stockCost.input.internationFreight.data) / parseFloat(this.inputData.stockCost.input.stockNum.data);
        num = Math.round(num * 100) / 100
        return num.toFixed(2);
      },
      // 亚马逊佣金
      ACommission(){
        if(this.inputData.productRevenue.input.sellingPrice.data === ''){
          return '0.00'
        }
        let num =  parseFloat(this.Rate[this.inputData.sellerInfo.input.countrySite.data]) * parseFloat(this.inputData.productRevenue.input.sellingPrice.data)
          * parseFloat(this.inputData.operatingExpenses.input.commission.data) / 100;
        num = Math.round(num * 100) / 100
        return num.toFixed(2);
      },
      // 月广告费用分摊
      MACSharing(){
        if(!this.inputData.operatingExpenses.input.advertisingFee.data){
          return '0.00'
        }
        let num = parseFloat(this.inputData.operatingExpenses.input.advertisingFee.data) * parseFloat(this.Rate[this.inputData.sellerInfo.input.countrySite.data])
          / this.calcNum;
        num = Math.round(num * 100) / 100
        return num.toFixed(2);
      },
      // 月站内Deal费用分摊
      DealSharing(){
        if(!this.inputData.operatingExpenses.input.dealFee.data){
          return '0.00'
        }
        let num = parseFloat(this.inputData.operatingExpenses.input.dealFee.data) * parseFloat(this.Rate[this.inputData.sellerInfo.input.countrySite.data]) / this.calmNum
        num = Math.round(num * 100) / 100
        return num.toFixed(2);
      },
      // 月站内CouPon费用分摊
      CouponSharing(){
        if(!this.inputData.operatingExpenses.input.couponFee.data){
          return '0.00'
        }
        let num = parseFloat(this.inputData.operatingExpenses.input.couponFee.data) * parseFloat(this.Rate[this.inputData.sellerInfo.input.countrySite.data]) / this.calmNum
        num = Math.round(num * 100) / 100
        return num.toFixed(2);
      },
      // 月刷单费用分摊
      AOMFees(){
        if(!this.inputData.operatingExpenses.input.billingFee.data){
          return '0.00'
        }
        let num = parseFloat(this.inputData.operatingExpenses.input.billingFee.data) / this.calcNum;
        num = Math.round(num * 100) / 100
        return num.toFixed(2);
      },
      // 站外月引流费用分摊
      OMDCSharing(){
        if(!this.inputData.operatingExpenses.input.drainageFee.data){
          return '0.00'
        }
        let num = parseFloat(this.inputData.operatingExpenses.input.drainageFee.data) / this.calcNum;
        num = Math.round(num * 100) / 100
        return num.toFixed(2);
      },
      // 其他站点软件月费分摊
      AOSMFAllocation(){
        if(!this.inputData.sellerInfo.input.otherFee.data  || this.listing === '' || this.calType == 1){
          return '0.00'
        }
        if(this.calType == 0){
          let num = parseFloat(this.inputData.sellerInfo.input.otherFee.data)
            / this.calmNum;
          num = Math.round(num * 100) / 100
          return num.toFixed(2);
        }else{
          let num = parseFloat(this.inputData.sellerInfo.input.otherFee.data)
            / parseFloat(this.listing);
          num = Math.round(num * 100) / 100
          return num.toFixed(2);
        }
      },
      // 专业卖家月费分摊
      PSMAllocation(){
        if(this.inputData.sellerInfo.input.sellerType.data === '' || this.listing === '' || this.calType == 1){
          return '0.00'
        }
        if(this.inputData.sellerInfo.input.sellerType.data === 1){
          return Math.round((0.99 * parseFloat(this.Rate[0])) * 100) / 100
        }
        if(this.calType == 0){
          let num = parseFloat(this.membershipFee[this.inputData.sellerInfo.input.sellerType.data][this.inputData.sellerInfo.input.countrySite.data])
            * parseFloat(this.Rate[this.inputData.sellerInfo.input.countrySite.data])
            / this.calmNum
          num = Math.round(num * 100) / 100
          return num.toFixed(2);
        }else{
          let num = parseFloat(this.membershipFee[this.inputData.sellerInfo.input.sellerType.data][this.inputData.sellerInfo.input.countrySite.data])
            * parseFloat(this.Rate[this.inputData.sellerInfo.input.countrySite.data])
            / parseFloat(this.listing)
          num = Math.round(num * 100) / 100
          return num.toFixed(2);
        }
      },
      // 销售提成分摊
      OOCAllocation(){
        if(!this.inputData.productRevenue.input.sellingPrice.data){
          return '0.00'
        }
        let num = parseFloat(this.inputData.productRevenue.input.sellingPrice.data) * parseFloat(this.Rate[this.inputData.sellerInfo.input.countrySite.data]) *
          parseFloat(this.inputData.operatingExpenses.input.salesCommission.array[this.inputData.operatingExpenses.input.salesCommission.data]) / 100;
        num = Math.round(num * 100) / 100
        return num.toFixed(2);
      },
      // 采购与运营成本分摊
      PAOperation(){
        if(!this.inputData.productRevenue.input.sellingPrice.data){
          return '0.00'
        }
        let num = parseFloat(this.inputData.productRevenue.input.sellingPrice.data) * parseFloat(this.Rate[this.inputData.sellerInfo.input.countrySite.data]) *
          parseFloat(this.inputData.operatingExpenses.input.operationCommission.array[this.inputData.operatingExpenses.input.operationCommission.data]) / 100;
        num = Math.round(num * 100) / 100
        return num.toFixed(2);
      },
      // 坏品损耗分摊
      BPLAllocation(){
        if(!this.inputData.productRevenue.input.disposalNum.data || this.inputData.productRevenue.input.showSales.data === ''  || !this.PPCost || !this.IUFreight
          || !this.DUFreight || !this.ACommission || !this.ALShipping || !this.AWDCFee ){
          return '0.00'
        }
        let num = (parseFloat(this.PPCost) + parseFloat(this.DUFreight) + parseFloat(this.IUFreight) +  parseFloat(this.ACommission) + parseFloat(this.ALShipping) + parseFloat(this.ITariff) + parseFloat(this.OPCost))
          * parseFloat(this.inputData.productRevenue.input.disposalNum.data) / this.calmNum;
        num = Math.round(num * 100) / 100
        return num.toFixed(2);
      },
      // 退货损耗分摊
      RLAllocation(){
        if(this.inputData.productRevenue.input.sellingPrice.data === '' ||this.inputData.productRevenue.input.sellingPrice.data === '' || this.ALShipping === 0 ||
          this.inputData.productRevenue.input.returnNum.data === '' || this.inputData.productRevenue.input.returnNum.data === 0 ){
          return '0.00'
        }
        let num = 0.2 * (0.15 * parseFloat(this.inputData.productRevenue.input.sellingPrice.data)
          * parseFloat(this.Rate[this.inputData.sellerInfo.input.countrySite.data])) * parseFloat(this.inputData.productRevenue.input.returnNum.data) /
          this.calmNum;
        num = Math.round(num * 100) / 100
        return num.toFixed(2);
      },
      // 收汇损失
      FELoss(){
        if(this.inputData.operatingExpenses.input.recoveryLossRate.data === '' ){
          return '0.00'
        }
        let num = (parseFloat(this.PRevenue) - parseFloat(this.ACommission) - parseFloat(this.ALShipping) -
          parseFloat(this.MACSharing) - parseFloat(this.BPLAllocation) - parseFloat(this.RLAllocation) - parseFloat(this.WCSharing) - parseFloat(this.PSMAllocation) -
          parseFloat(this.AWDCFee)) * parseFloat(this.inputData.operatingExpenses.input.recoveryLossRate.data) * 0.01;
        if(num <= 0){
          return '0.00'
        }
        num = Math.round(num * 100) / 100
        return num.toFixed(2);
      },
      // 商品收入
      PRevenue(){
        if(this.inputData.productRevenue.input.sellingPrice.data === '' || this.inputData.productRevenue.input.sellingPrice.data === 0){
          return '0.0'
        }
        let num = parseFloat(this.inputData.productRevenue.input.sellingPrice.data) * parseFloat(this.Rate[this.inputData.sellerInfo.input.countrySite.data])
        num = Math.round(num * 10) / 10
        return num.toFixed(1);
      },
      // 商品净利润
      PGProfit(){
        if(this.PRevenue && this.TCost){
          let num = this.PRevenue - this.TCost;
          num = Math.round(num * 100) / 100;
          return num.toFixed(1);
        }
        return '0.00'
      },
      // 实际销量
      ASales(){
        if(this.inputData.productRevenue.input.returnNum.data === '' || this.inputData.productRevenue.input.showSales.data === ''
          || this.inputData.productRevenue.input.disposalNum.data === ''){
          return 0
        }
        let num = parseFloat(this.inputData.productRevenue.input.showSales.data) - parseFloat(this.inputData.productRevenue.input.returnNum.data)
          - parseFloat(this.inputData.productRevenue.input.disposalNum.data)
        num = Math.round(num)
        return num;
      },
      // 当月销售利润率
    salePGMargin(){
      if(this.CostCapital === 0 || this.ASales === 0 || this.inputData.productRevenue.input.showSales.data === 0){
          return '0.0'
        }
        let num = (parseFloat(this.PGProfit) / parseFloat(this.PRevenue)) * 100

        // 旧版
        // if((parseFloat(this.PPCost) + parseFloat(this.DUFreight) + parseFloat(this.IUFreight) + parseFloat(this.AWDCFee)) <= 0){
        //   return '0.0'
        // }
        // let num = parseFloat(this.ATGPOTPFTMonth) / ((parseFloat(this.PPCost) + parseFloat(this.DUFreight) + parseFloat(this.IUFreight)+ parseFloat(this.ITariff) + parseFloat(this.OPCost)) * this.calmNum) * 100
        // num = Math.round(num * 10) / 10
        return num.toFixed(1);
    },
      // 商品净利率
      PGMargin(){
        if(this.CostCapital === 0 || this.ASales === 0){
          return '0.0'
        }
        // 商品利润 / 出资成本 * 100%
        let num = (parseFloat(this.PGProfit) / parseFloat(this.CostCapital)) * 100

        // 旧版
        // if((parseFloat(this.PPCost) + parseFloat(this.DUFreight) + parseFloat(this.IUFreight) + parseFloat(this.AWDCFee)) <= 0){
        //   return '0.0'
        // }
        // let num = parseFloat(this.ATGPOTPFTMonth) / ((parseFloat(this.PPCost) + parseFloat(this.DUFreight) + parseFloat(this.IUFreight)+ parseFloat(this.ITariff) + parseFloat(this.OPCost)) * this.calmNum) * 100
        // num = Math.round(num * 10) / 10
        return num.toFixed(1);
      },
      // 仓储费用
      WCSharing(){
        if(this.inputData.productRevenue.input.positionDay.data === '' || !this.inputData.productRevenue.input.showSales.data || !this.inputData.packData.input.long.data
          || !this.inputData.packData.input.width.data || !this.inputData.packData.input.height.data){
          return '0.00'
        }
        let num
        let setFee = parseFloat(this.inputData.packData.input.long.data) * parseFloat(this.inputData.packData.input.width.data) *
          parseFloat(this.inputData.packData.input.height.data) * parseFloat(this.warehouseFeeMonthly.substr(1)) *
          parseFloat(this.Rate[this.inputData.sellerInfo.input.countrySite.data]) / 30 / 1000000 / this.calmNum
        if(this.unitIndex){
          num = setFee * (15 * this.inputData.productRevenue.input.showSales.data + 30 * this.inputData.productRevenue.input.positionDay.data)
            * 2.54 * 2.54 * 2.54
        }else {
          num = setFee * (15 * this.inputData.productRevenue.input.showSales.data + 30 * this.inputData.productRevenue.input.positionDay.data)
        }
        num = Math.round(num * 100) / 100
        return num.toFixed(2)
      },
      // 成本与费用合计
      TCost(){
        let num = 0;
        num = parseFloat(this.PPCost) + parseFloat(this.DUFreight) + parseFloat(this.IUFreight )+ parseFloat(this.ACommission)
          + parseFloat(this.ALShipping) + parseFloat(this.AWDCFee) + parseFloat(this.MACSharing) + parseFloat(this.AOMFees)
          + parseFloat(this.OMDCSharing) + parseFloat(this.AOSMFAllocation) + parseFloat(this.PSMAllocation)
          + parseFloat(this.OOCAllocation) + parseFloat(this.PAOperation) + parseFloat(this.BPLAllocation) + parseFloat(this.RLAllocation)
          + parseFloat(this.WCSharing) + parseFloat(this.FELoss) + parseFloat(this.OPCost) + parseFloat(this.FTESharing)
          + parseFloat(this.DealSharing) + parseFloat(this.CouponSharing);
        if(this.isTariff){
          num = num + parseFloat(this.ITariff) + parseFloat(this.CIVTax)
          num = Math.round(num * 10) / 10
          return num.toFixed(1);
        }else {
          num = Math.round(num * 10) / 10;
          return num.toFixed(1);
        }

      },
    },
    methods: {
         // 卖家固定费用按钮点击事件
    clickmjgdfy(index){
      this.showLoadingIcon = true
      let timer = setTimeout(() => {
        this.showLoadingIcon = false
        this.calType = index
        clearTimeout(timer)
      }, 200)
    },
    clickmjgdfy1(){
      this.showLoadingIcon1 = true
      let timer = setTimeout(() => {
        this.showLoadingIcon1 = false
        clearTimeout(timer)
      }, 200)
    },
    openTriVis(type){
      this.triVistable = true
      this.triVistableType = type
    },
      linkRegister(){
        this.$message.warning('功能处理中')
        // this.$router.push('/registed123456')
      },

      moveDialog(e){
        // console.log(e)
        let odiv = e.target;        //获取目标元素

            //算出鼠标相对元素的位置
            let disX = e.clientX - odiv.offsetLeft;
            let disY = e.clientY - odiv.offsetTop;
            document.onmousemove = (e)=>{       //鼠标按下并移动的事件
                //用鼠标的位置减去鼠标相对元素的位置，得到元素的位置
                let left = e.clientX - disX -140;
                let top = e.clientY - disY -20;
                //绑定元素位置到positionX和positionY上面
                this.positionX = top - 60;
                this.positionY = left - 60;

                //移动当前元素
                odiv.style.left = left + 'px';
                odiv.style.top = top + 'px';
            };
            document.onmouseup = () => {
                document.onmousemove = null;
                document.onmouseup = null;
            };
      },
      cancelShow(){
        this.dialogShow = false
      },
      cancelDialog(){
        this.$emit('dialogShow', false)
        this.isChange = false
        this.move()
      },
      //禁止滚动
      stop(){
        var mo=function(e){
          e.preventDefault();
        };
        document.body.style.overflow='hidden';
        document.addEventListener("touchmove",mo,false);//禁止页面滑动
      },

      //取消滑动限制
      move(){
        var mo=function(e){
          e.preventDefault();
        };
        document.body.style.overflow='';//出现滚动条
        document.removeEventListener("touchmove",mo,false);
      },

      navigatorHref(i){
        if(i === 0){
          // window.open('/register/static/1.html')
          window.open('/law/WhaleERP用户服务条款.html')
        }
        else if (i === 1){
          // window.open('/register/static/2.html')
          window.open('/law/WhaleERP隐私政策.html')

        }
      },
      // 单位切换
      unitClick(){
        if(!this.unitIndex){
          if(this.inputData.packData.input.long.data !== ''){
            if((Math.round(this.aNum * 100) / 100).toFixed(2) === this.inputData.packData.input.long.data){
              this.inputData.packData.input.long.data = (Math.round(this.aNum * 0.393700787 * 100) / 100).toFixed(2)
            }else{
              this.aNum = this.inputData.packData.input.long.data * 0.393700787
              this.inputData.packData.input.long.data = (Math.round(this.aNum * 100) / 100).toFixed(2)
            }
          }
          if(this.inputData.packData.input.width.data !== ''){
            if((Math.round(this.bNum * 100) / 100).toFixed(2) === this.inputData.packData.input.width.data){
              this.inputData.packData.input.width.data = (Math.round(this.bNum * 0.393700787 * 100) / 100).toFixed(2)
            }else{
              this.bNum = this.inputData.packData.input.width.data * 0.393700787
              this.inputData.packData.input.width.data = (Math.round(this.bNum * 100) / 100).toFixed(2)
            }
          }
          if(this.inputData.packData.input.height.data !== ''){
            if((Math.round(this.cNum * 100) / 100).toFixed(2) === this.inputData.packData.input.height.data){
              this.inputData.packData.input.height.data = (Math.round(this.cNum * 0.393700787 * 100) / 100).toFixed(2)
            }else{
              this.cNum = this.inputData.packData.input.height.data * 0.393700787
              this.inputData.packData.input.height.data = (Math.round(this.cNum * 100) / 100).toFixed(2)
            }
          }
          if(this.inputData.packData.input.weight.data !== ''){
            if((Math.round(this.dNum * 100) / 100).toFixed(2) === this.inputData.packData.input.weight.data){
              this.inputData.packData.input.weight.data = (Math.round(this.dNum * 2.20462262 * 100) / 100).toFixed(2)
            }else{
              this.dNum = this.inputData.packData.input.weight.data * 2.20462262
              this.inputData.packData.input.weight.data = (Math.round(this.dNum * 100) / 100).toFixed(2)
            }
          }
        }else {
          if(this.inputData.packData.input.long.data !== ''){
            if((Math.round(this.aNum * 100) / 100).toFixed(2) === this.inputData.packData.input.long.data){
              this.inputData.packData.input.long.data = (Math.round(this.aNum * 2.54 * 100) / 100).toFixed(2)
            }else{
              this.aNum = this.inputData.packData.input.long.data * 2.54
              this.inputData.packData.input.long.data = (Math.round(this.aNum * 100) / 100).toFixed(2)
            }
          }
          if(this.inputData.packData.input.width.data !== ''){
            if((Math.round(this.bNum * 100) / 100).toFixed(2) === this.inputData.packData.input.width.data){
              this.inputData.packData.input.width.data = (Math.round(this.bNum * 2.54 * 100) / 100).toFixed(2)
            }else{
              this.bNum = this.inputData.packData.input.width.data * 2.54
              this.inputData.packData.input.width.data = (Math.round(this.bNum * 100) / 100).toFixed(2)
            }
          }
          if(this.inputData.packData.input.height.data !== ''){
            if((Math.round(this.cNum * 100) / 100).toFixed(2) === this.inputData.packData.input.height.data){
              this.inputData.packData.input.height.data = (Math.round(this.cNum * 2.54 * 100) / 100).toFixed(2)
            }else{
              this.cNum = this.inputData.packData.input.height.data * 2.54
              this.inputData.packData.input.height.data = (Math.round(this.cNum * 100) / 100).toFixed(2)
            }
          }
          if(this.inputData.packData.input.weight.data !== ''){
            if((Math.round(this.dNum * 100) / 100).toFixed(2) === this.inputData.packData.input.weight.data){
              this.inputData.packData.input.weight.data = (Math.round(this.dNum * 0.45359237 * 100) / 100).toFixed(2)
            }else{
              this.dNum = this.inputData.packData.input.weight.data * 0.45359237
              this.inputData.packData.input.weight.data = (Math.round(this.dNum * 100) / 100).toFixed(2)
            }
          }
        }
        this.unitIndex = (this.unitIndex + 1) % 2
        this.$emit('getUIndex', this.unitIndex)
      },
      // 保存数据
      saveData(){

        request({
          url: '/support-server/log/visit/updateProductFront',
          method: 'post',
          header: {
            'Content-Type': 'application/json'
          },
        })
        let isError = false;
        for (let i in this.inputData){
          for (let j in this.inputData[i].input){
            if(this.inputData[i].input[j].isShow){
              if(!this.inputData[i].input[j].data && this.inputData[i].input[j].data !== 0) {
                this.inputData[i].input[j].isInput = false;
                isError = true;
              }
            }
          }
        }
        if(isError)
          alert('请将信息补充完整');
        else
          this.sendData()
      },
      // 发送数据
      sendData(){
        request({
          url: '/user/userInfo',
          method: 'post',
          header: {
            'Content-Type': 'application/json'
          }
        }).then(res => {
          if(res.data.code === 1){
            this.move()
            this.$router.push('/userInfo')

          }
          else if(res.data.code === 1020 || res.data.code === 1000){
            this.isLogin = true
          }
          else{
            this.$message.error(res.data.info)
          }
        })
        // request({
        //   url: '/product/addProduct',
        //   method: 'post',
        //   header: {
        //     'Content-Type': 'application/json'
        //   },
        //   data: {
        //     "sizeLength": this.inputData.packData.input.long.data,
        //     "sizeWidth": this.inputData.packData.input.width.data,
        //     "sizeHeight": this.inputData.packData.input.height.data,
        //     "weight": this.inputData.packData.input.weight.data,
        //     "commission": this.inputData.packData.input.commission.data,
        //     "productType": this.inputData.packData.input.sort.data,
        //     "unit": this.inputData.packData.input.unit.data,
        //     "purchaseNum": this.inputData.stockCost.input.stockNum.data,
        //     "purchasePrice": this.inputData.stockCost.input.stockPrice.data,
        //     "domesticFreight": this.inputData.stockCost.input.domesticFreight.data,
        //     "foreignFreight": this.inputData.stockCost.input.internationFreight.data,
        //     "monthlyAdvertisingFee": this.inputData.operatingExpenses.input.advertisingFee.data,
        //     "fakeOrderFee": this.inputData.operatingExpenses.input.billingFee.data,
        //     "attractPeopleFee": this.inputData.operatingExpenses.input.drainageFee.data,
        //     "saleCommissionRate": this.shareArray[this.inputData.operatingExpenses.input.salesCommission.data],//销售提成率
        //     "buyAndOperationCommissionRate": this.shareArray[this.inputData.operatingExpenses.input.operationCommission.data], //采购与运营提成率
        //     "otherFee": this.inputData.sellerInfo.input.otherFee.data,
        //     "productPrice": this.inputData.productRevenue.input.sellingPrice.data,
        //     "damageProduct": this.inputData.productRevenue.input.disposalNum.data,
        //     "returnProduct": this.inputData.productRevenue.input.returnNum.data,
        //     "inWarehouseNum": this.inputData.productRevenue.input.positionDay.data,
        //     "productSales": this.inputData.productRevenue.input.showSales.data,
        //     "countrySite": this.inputData.sellerInfo.input.countrySite.data,
        //     "sellerType": this.inputData.sellerInfo.input.sellerType.data,
        //     "mergeConfiguration": this.inputData.sellerInfo.input.warehouseConfiguration.data,
        //     "lengthType": this.unitIndex,
        //     "weightType": this.unitIndex,
        //     "returnLossRate": this.inputData.operatingExpenses.input.recoveryLossRate.data,
        //     "customsPrice": this.inputData.stockCost.input.saleTax.data,
        //     "monthlyFinanceAndTaxation": this.inputData.sellerInfo.input.taxExpense.data,
        //     "importDuty": this.inputData.stockCost.input.importTariff.data,
        //     "operationInterestRateYearly": this.inputData.operatingExpenses.input.operatingAnnualInterestRate.data,
        //     'calType': this.calType
        //   }
        // }).then(res => {
        //   if(res.data.code === 1){
        //     this.$message.success('保存成功')
        //     this.$router.push({
        //       path: '/userInfo',
        //       query: {
        //         inputId: true
        //       }
        //     })
        //   }else if(res.data.code === 1020 || res.data.code === 1000){
        //     this.isLogin = true
        //   }else{
        //     this.$message.error(res.data.info)
        //   }
        // })
      },
      // 修改数据
      changeData(){
        request({
          url: '/support-server/log/visit/updateProductFrontPage',
          method: 'post',
          header: {
            'Content-Type': 'application/json'
          },
        })
        this.isChange = !this.isChange
      },
      // 显示输入款细节
      showDetail(index, i){
        let that = this
        clearTimeout(that.inputTimer)
        this.inputTimer = setTimeout(() => {
          that.inputData[index].input[i].showDetail = true
        }, 500)
      },
      showCalmDetail(index){
        let that = this
        clearTimeout(that.inputTimer)
        this.inputTimer = setTimeout(() => {
          that.showDetailCalm[index] = true
          // 强制刷新页面
          this.$forceUpdate();
        }, 500)
      },
      // 隐藏输入框细节
      cancelDetail(index, i){
        clearTimeout(this.inputTimer)
        this.inputTimer = null
        this.inputData[index].input[i].showDetail = false
      },
      cancelCalmDetail(index){
        clearTimeout(this.inputTimer)
        this.inputTimer = null
        this.showDetailCalm[index] = false
        // 强制刷新页面
        this.$forceUpdate();
      },
      optionClick(index, i){
        this.inputData[index].input[i].isInput = true
        if(i == 'xxts'){
          this.clickmjgdfy1()
          if(this.inputData[index].input[i].data === 0){
            this.inputData.stockCost.input.sqbs.data = 1
            this.inputData.stockCost.input.importTariff.isDisable = false
          }else if(this.inputData[index].input[i].data === 1){
            this.inputData.stockCost.input.importTariff.data = 0
            this.inputData.stockCost.input.importTariff.isDisable = true
            this.inputData.stockCost.input.sqbs.data = 0
          }
        }
        if(this.inputData.sellerInfo.input.countrySite.data !== 0){
          this.inputData.sellerInfo.input.warehouseConfiguration.data = 0
          this.inputData.sellerInfo.input.warehouseConfiguration.isInput = true
          this.inputData.sellerInfo.input.warehouseConfiguration.isDisable = true
        }else {
          this.inputData.sellerInfo.input.warehouseConfiguration.isDisable = false
          this.inputData.sellerInfo.input.warehouseConfiguration.isInput = true
        }
        if(this.inputData.sellerInfo.input.countrySite.data !== '' && this.inputData.packData.input.sort.data !== '' &&
          this.inputData.sellerInfo.input.warehouseConfiguration.data.data !== '' && this.inputData.packData.input.long.data !== '' &&
          this.inputData.packData.input.width.data !== '' && this.inputData.packData.input.weight.data !== '' && this.inputData.packData.input.height.data !== ''){
          this.isUpdate = true
        }
        if(this.inputData.sellerInfo.input.countrySite.data !== 0 && this.inputData.sellerInfo.input.countrySite.data !== 1 && this.inputData.sellerInfo.input.countrySite.data !== 8 && this.inputData.sellerInfo.input.countrySite.data !== 7){
          this.isTariff = true
        }else {
          this.isTariff = false
        }

        if(i === 'sort' || i === 'warehouseConfiguration' || i === 'countrySite'){
          this.isUpdate = true
        }else {
          this.isUpdate = false
        }
        if( i === 'countrySite'){
          request({
            url: '/info/getImportVat',
            method: 'post',
            header: {
              'Content-Type': 'application/json'
            },
            data: {
              "countrySite": this.inputData.sellerInfo.input.countrySite.data
            }
          }).then(res => {
            if(res.data.code === 1){
              this.importVAT = res.data.info
            }else if(res.data.code === 1001){
              this.importVAT = 0
            }
          }).catch(err => {
            console.log(err)
          })
          request({
            url: '/product/getSales',
            method: 'post',
            header: {
              'Content-Type': 'application/json'
            },
            // data:{
            //   "countryArea": this.inputData.sellerInfo.input.countrySite.data === 0 || this.inputData.sellerInfo.input.countrySite.data === 1 ? 0 :
            //     this.inputData.sellerInfo.input.countrySite.data === 2 ? 1 :
            //       this.inputData.sellerInfo.input.countrySite.data === 3 || this.inputData.sellerInfo.input.countrySite.data === 4 ||
            //       this.inputData.sellerInfo.input.countrySite.data === 5 || this.inputData.sellerInfo.input.countrySite.data === 6 ? 2 :
            //         this.inputData.sellerInfo.input.countrySite.data === 7 ? 3 : 4,
            //   "productId": null
            // }
          }).then(res => {
            if(res.data.code === 1){
              this.Listing = res.data.info - this.calmNum
            }else{
              this.Listing = 0
            }
          }).catch(err => {
            console.log(err)
          })
        }
      },
      //离开输入框后增加小数点
      clearNumber(value, index, i) {
        if(this.inputData[index].input[i].data !== ''){
          this.inputData[index].input[i].isInput = true
          if(parseFloat(this.inputData[index].input[i].data) < 0){ // 数据不能小于0
            alert(this.inputData[index].input[i].name + '数据有误')
            this.inputData[index].input[i].data = ''
          }else if(i === 'long' || i === 'width' || i === 'height' || i === 'weight' || i === 'stockNum' || i === 'stockPrice' || i === 'internationFreight' ||
            i === 'sellingPrice' || i === 'ListingNum'){
            if(parseFloat(this.inputData[index].input[i].data) === 0){
              alert(this.inputData[index].input[i].name+'不能为0')
              this.inputData[index].input[i].data = ''
              this.inputData[index].input[i].isInput = false
            }
          }
          if((i === 'long' || i === 'width' || i === 'height' || i === 'commission') && this.unitIndex === 0){ // 保留一位小数
            this.inputData[index].input[i].data = parseFloat(value).toFixed(1);
          }else if(i === 'stockNum' || i === 'domesticFreight' || i === 'internationFreight' || i === 'billingFee' ||
            i ==='drainageFee' || i === 'showSales' || i === 'disposalNum' || i === 'returnNum' || i === 'otherFee' ||
            i === 'positionDay' || i === 'ListingNum' || i === 'importTariff' || i === 'taxExpense'){ // 保留整数
            this.inputData[index].input[i].data = parseFloat(value).toFixed(0);
          }else if(i === 'operatingAnnualInterestRate'){
            this.inputData[index].input[i].data = parseFloat(value).toFixed(1);
          }else { // 保留两位小数
            this.inputData[index].input[i].data = parseFloat(value).toFixed(2);
          }
        }else if(this.inputData[index].input[i].data === ''){
          this.inputData[index].input[i].isInput = false
        }
      },
      selectBlur(value,index,i){
        if(this.inputData[index].input[i].data !== ''){
          this.inputData[index].input[i].isInput = true
        }
        if(this.inputData[index].input[i].data === ''){
          this.inputData[index].input[i].isInput = false
        }
      },
      getInput(index ,i){
        if(i === 'long' || i === 'width' || i === 'weight' || i === 'height'){
          this.$emit('cancelUpdate', true)
        }else {
          this.$emit('cancelUpdate', false)
        }
      },
      sendPhone(){
        request({
          url: '/register/submitInfo',
          method: 'post',
          header:{
            'Content-Type': 'application/json'
          },
          data: {
            'username': this.loginName,
            'password': this.password,
            'confirmPassword': this.againPassword,
            'phone': this.phoneName + this.phone,
            'verity': this.verity,
          }
        }).then(res => {
          if(res.data.code === 1){
            request({
              url: '/register/getSms',
              method: 'post',
              header: {
                'Content-Type': 'application/json'
              },
              data: {
                "param": this.phoneName + this.phone
              }
            }).then(res => {
              if(res.data.code === 1){
                if(!this.timer){
                  this.time = 60
                  this.timer = setInterval(() => {
                    if(this.time > 0 && this.time <= 60){
                      this.time --
                    }else {
                      clearInterval(this.timer);
                      this.timer = null
                    }
                  }, 1000)
                }
              }else {
                this.time = 0
                this.$message.error(res.data.info)
              }
            })
          }else {
            this.$message.error(res.data.info)
            this.imgClick()
          }
        })

      },
      sendLoginPhone(){
        request({
          url:'/user/login/loginCode',
          method:'post',
          header: {
            'Content-Type': 'application/json'
          },
          data:{
            "param": this.loginEmail
          }
        }).then(res => {
          if(res.data.code === 1){
            this.isSendPhone = true
            this.$message.success('请在60s内填写')
            if(!this.timer2){
              this.time2 = 60
              this.timer2 = setInterval(() => {
                if(this.time2 > 0 && this.time2 <= 60){
                  this.time2 --
                }else {
                  clearInterval(this.timer2);
                  this.timer2 = null
                  this.isSendPhone = false
                }
              }, 1000)
            }
          }else {
            this.time2 = 0
            this.$message.error(res.data.info)
          }
        })
      },
      // 注册按钮点击
      btnRegisterClick(){
        request({
          url: '/register/register',
          method: 'post',
          header:{
            'Content-Type': 'application/json'
          },
          data: {
            'phone': this.phoneName + this.phone,
            "verity": this.phoneVerity
          }
        }).then(res => {
          if(res.data.code === 1){
            this.$message.success('注册成功')
            this.isRegister = false
            this.isLogin = true
          }else {
            this.$message.error(res.data.info)
            this.imgClick()
          }
        })
      },
      // 点击切换验证码
      imgClick(){
        this.imgSrc = this.imgSrc + '?' + new Date()
      },
      loginImgClick(){
        this.loginImgSrc = this.loginImgSrc + '?' + new Date()
      },
      // 关闭登录弹窗
      cancelLogin(){
        this.isLogin = false
      },
      // 立即注册
      loginRegister(){
        request({
          url: '/support-server/log/visit/toRegisterPage',
          method: 'post',
          header: {
            'Content-Type': 'application/json'
          },
        })
        this.isLogin = false
        this.isRegister = true
      },
      // 关闭注册弹窗
      cancelRegister(){
        this.isRegister = false
      },
      // 登录弹窗登录按钮
      btnLoginClick(){
        request({
          url: '/tryLogin.action',
          method: 'post',
          header: {
            'Content-Type': 'application/json'
          },
          data: {
            'username': this.loginEmail,
            'password': this.loginPassword,
            'code': this.phoneCode,
            "verity": this.loginVerity
          }
        }).then(res => {
          if(res.data.code === 1){
            this.$message.success('登录成功')
            this.sendData()
          }else if(res.data.code === 1020){
            sessionStorage.removeItem("JSESSIONID");
            sessionStorage.clear();
          }else if(res.data.code === 1041){
            this.$message.error('另一台设备在线，如需继续登录，请获取手机验证码登录')
            this.doubleLogin = true
            this.phoneCode = ''
          } else {
            this.$message.error(res.data.info)
            this.loginImgClick()
          }
        }).catch(err => {
          console.log(err)
        })
      },
      focus1(){
        this.show1 = true
      },
      blur1(){
        this.show1 = false
      },
      focus2(){
        this.show2 = true
      },
      blur2(){
        this.show2 = false
      },
      focus3(){
        this.show3 = true
      },
      blur3(){
        this.show3 = false
      },
    },
  }
</script>

<style scoped lang="scss">
::v-deep{
  .el-dialog__body{
    padding: 0 20px 30px;
  }
}

@media screen and (max-width: 1600px) {
  .img-close{
    /* left: 73%; */
    right: 5%;
  }
  .exchange_rate{
    margin-right: 0.8rem;
    font-size: 1.2rem;
  }

  .input_module_content{
    width: 1240px;
    padding: 0.8rem 1rem 2.5rem 1rem;
    margin: 10px auto;
  }
  .new-tipss{
    width: 1200px;
    padding: 1rem 1rem;
  }

  .close_dialog{
    width: 2.8rem;
    height: 2.8rem;
  }

  .input_content_title, .cost_title{
    margin: 0.5rem 0.4rem;
    font-size: 1.6rem;
  }

  .cost_title1{
    font-size: 1.6rem;
  }

  .input_content_title{
    font-size: 2rem;
  }

  .input_module{
    margin: 0.8rem 0.4rem;
    font-size: 1rem;
  }

  .input_title{
    font-size: 1.4rem;
    margin-bottom: 1.8rem;
  }

  .input_content{
    /* margin: 0.8rem 0; */
    font-size: 1.1rem;
  }

  .input_content1{
    margin: 0.2rem 0
  }

  .input_detail{
    width: 9rem;
  }

  .input_text{
    width: 6rem;
  }

  .input_icon{
    width: 1.2rem;
    height: 2rem;
    padding-top: 4px;
  }

  .input_name_1{
    width: 6rem;
  }

  .input_name_3{
    width: 10rem;
  }

  .input_name_2{
    width: 13rem;
  }


  .input_unit{
    position: relative;
    margin-left: 0.1rem;
    margin-top: 0.4rem;
    width: 2.2rem;
    font-size: 1rem;
  }

  .input_btn{
    padding: 0.3rem 0.5rem;
    margin-left: 0.1rem;
    font-size: 1rem;
    border-radius: 0.4rem;
  }

  .select_text{
    width: 7.2rem;
    height: 1.8rem;
    /* font-size: 0.99rem; */
  }


  .cost_left_content{
    padding: 1rem;
  }

  .cost_right_content{
    padding: 0.5rem;
  }

  .cost_left_total{
    /*margin: 0 1.8rem;*/
  }

  .cost_left_row{
    margin: 0.8rem 1rem;
    font-size: 1.1rem;
  }

  .cost_left_row_title{
    width: 16rem;
  }

  .cost_left_row1{
    margin: 0.7rem;
    font-size: 1.1rem;
  }

  .cost_top{
    margin: 3.2rem 0.8rem 0.8rem 0.8rem;
  }

  .cost_title1{
    margin: 0 0.8rem 0 0.8rem;
  }

  .cost_left_row_right{
    width: 8rem;
    font-size: 1.2rem;
    height: 1.8rem;
    line-height: 1.8rem;
  }


  .cost_left_bottom{
    width: 80rem;
    /*margin: 0 1.8rem;*/
  }

  .left_bottom_left{
    margin: 1rem 1rem;
    font-size: 1.6rem;
  }

  .left_bottom_right{
    margin: 1rem 6rem;
    font-size: 1.6rem;
  }


  .btn{
    margin: 0 1rem;
  }

  .calm_button{
    padding: 0.5rem 3rem;
    font-size: 1.4rem;
    border-radius: 0.2rem;
    margin: 0 2rem;
  }

  .curr_self{
    font-size: 1rem;
  }

  .top_input{
    width: 100px;
    border-radius: 5px;
    height: 25px;
    padding: 5px;
    font-size: 12px;
  }

  .input_item_detail, .input_item_detail1 {
    margin: -6px 0 0 -40px;
    width: 480px;
    font-size: 8px;
    line-height: 15px;
    border-radius: 8px;
    padding: 5px;
  }

  .input_item_detail3{
    margin: -6px 0 0 -40px;
    width: 600px;
    font-size: 8px;
    line-height: 15px;
    border-radius: 8px;
    padding: 5px;
  }
}

@media screen and (min-width: 1600px){
  .img-close{
    right: 10%;
  }
  .exchange_rate{
    margin-right: 10px;
    font-size: 14px;
  }

  .input_module_content{
    width: 1400px;
    padding: 10px 10px 40px 10px;
    margin: 10rem auto;
  }

  .new-tipss{
    width: 1360px;
    padding: 10px 10px;
  }

  .close_dialog{
    width: 30px;
    height: 30px;
  }

  .input_content_title, .cost_title{
    margin: 10px;
    font-size: 20px;
  }

  .cost_title1{
    font-size: 20px;
  }

  .input_content_title{
    font-size: 25px;
    /* margin-left: -35px; */
  }

  .input_total_module{
    margin: 0 30px;
  }

  .input_module{
    margin: 10px 9px;
    font-size: 14px;
  }

  .input_title{
    font-size: 16px;
    margin-bottom: 20px;
  }

  .input_content{
    /* margin: 10px 0; */
    font-size: 12px;
  }

  .input_content1{
    margin: 5px 0;
  }

  .input_detail{
    width: 100px;
  }

  .input_text{
    width: 70px;
  }

  .input_icon{
    width: 14px;
    height: 22px;
    margin-top: -2px;
  }

  .input_name_1{
    width: 70px;
  }

  .input_name_3{
    width: 100px;
  }

  .input_name_2{
    width: 150px;
  }


  .input_unit{
    position: relative;
    margin-left: 3px;
    margin-top: 5px;
    width: 25px;
    font-size: 12px;
  }

  .input_btn{
    padding: 3px 5px;
    margin-left: 2px;
    font-size: 12px;
    border-radius: 5px;
  }

  .select_text{
    width: 100px;
    height: 20px;
    font-size: 12px;
  }


  .cost_left_content{
    padding: 10px;
  }

  .cost_left_total{
    margin: 0 20px;
  }

  .cost_left_row{
    margin: 10px;
    font-size: 12px;
  }

  .cost_left_row_title{
    width: 180px;
  }

  .cost_left_row1{
    margin: 7px;
    font-size: 12px;
  }

  .cost_top{
    margin: 40px 7px 7px 7px;
  }

  .cost_title1{
    margin: 0 7px 0 7px;
  }

  .cost_left_row_right{
    width: 120px;
    font-size: 14px;
    height: 20px;
    line-height: 20px;
  }


  .cost_left_bottom{
    width: 980px;
    margin: 0 20px;
  }

  .left_bottom_left{
    margin: 10px 20px;
    font-size: 18px;
  }

  .left_bottom_right{
    margin: 10px 66px 0;
    font-size: 18px;
  }


  .btn{
    margin: 0 10px;
  }

  .calm_button{
    padding: 10px 30px;
    font-size: 16px;
    border-radius: 3px;
    margin: 0 20px;
  }

  .curr_self{
    font-size: 12px;
  }

  .top_input{
    width: 100px;
    border-radius: 5px;
    height: 25px;
    padding: 5px;
    font-size: 12px;
  }

  .input_item_detail, .input_item_detail1, .input_item_detail3{
    margin: -6px 0 0 -40px;
    width: 240px;
    font-size: 8px;
    line-height: 15px;
    border-radius: 8px;
    padding: 5px;
  }
}
.dialog-bg{
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    /* min-width: 1980px; */
    height: 100%;
    min-height: 100vh;
    background-color: rgba(0, 0, 0, .5);
    z-index: 10;
  }

  .img-close{
    position: fixed;
        right: 0;
    height: 40px;
    width: 40px;
    padding: 5px 5px 19px 15px;
    border-radius: 0 0 0 40px;
    background-color: #00a0c7;
  }

  .img-close:hover{
    cursor: pointer;
    opacity: .8;
  }

  .dialog-container{
    background-color: #fff;
    border-radius: 5px;
    overflow: hidden;
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 20;
  }

  .dialog-main{
    padding: 5px 10px;
    background-color: #fff;
    border-radius: 5px;
    position: relative;
    margin: 10px 135px;
    width: 1250px;
  }
.new-tipss{
  /*margin: 5px 10px;*/
  /* margin-bottom: 20px; */
  display: inline-block;
  text-align: center;
  background-color: rgb(197,234,243);
  color: #727272;
  font-weight: bold;
  font-size: 14px;
}

.triangle-down {
  position: absolute;
  right: 20px;
  top: 7px;
  width: 0;
  height: 0;
  border-left: 3px solid transparent;
  border-right: 3px solid transparent;
  border-top: 6px solid black;
  &:hover{
    cursor: pointer;
    opacity: .8;
  }
}

.dialist{
  display: flex;
  margin: 10px 0;
  &-left{
    flex: 2
  }
  &-right{
    flex: 1;
    color: #00a0c7;
    position: relative;
    display: flex;
    justify-content: space-between;
    &__txt{
      text-align: end;
    }
    &--error{
      position: absolute;
      color: #fca605;
      transform: translate(-110%, 0);
      font-size: 12px;
      text-decoration: line-through;
    }
  }
}

.login_title{
  color: #00dfe3;
  min-width: 340px;
  font-size: 20px;
  font-weight: bold;
  padding: 10px 5px 20px;
  text-align: center;
}

.registered_title{
  color: #00dfe3;
  font-size: 20px;
  font-weight: bold;
  padding: 10px 5px;
  text-align: center;
}

.texting{
  position: absolute;
  top: 0;
  left: 0;
  width: 100px;
  height: 100px;
}

.texting:hover{
  cursor: pointer;
}

.exchange_rate{
  text-align: end;
}

.exchange_rate span{
  font-weight: 200;
}

.exchange_rate span b{
  color: rgb(136, 0, 21);
  font-weight: 600;
}

.input_module_content{
  display: block;
  /* margin: 10px 135px; */
  /* width: 1250px; */
  position: relative;
  background-color: #fff;
  border-radius: 5px;
}

.close_dialog{
  position: absolute;
  top: 0;
  right: 0;
}

.close_dialog:hover{
  cursor: pointer;
}

.input_content_title, .cost_title, .cost_title1{
  color: #00a0c7;
  font-weight: 800;
}

.cost_title1{
  position: absolute;
}

.input_module{
  float: left;
}

.input_title{
  color: black;
  font-weight: 600;
}

.input_content{
  display: flex;
}

.input_detail{
  display: flex;
  border: 1px solid #7f9db9;
  border-radius: 5px;
  overflow: hidden;
}

.input_text{
  border: none;
  outline: none;
  text-align: center;
  color: #7b7b7b;
}

.input_icon{
  padding-top: 4px;
  color: #7b7b7b;
  text-align: center;
  z-index: 1;
}

.input_name_1, .input_name_2, .input_name_3{
  color: #000000;
  margin-top: 5px;
}

.special_icon{
  color: #1fa9ef;
}

.input_btn{
  background-color: #00a0c7;
  color: #fff;
  text-align: center;
  user-select: none;
}

.input_btn:hover{
  opacity: .7;
  cursor: pointer;
}

.select_text{
  border: none;
  outline: none;
  text-align: center;
  text-align-last: center;
  overflow: hidden;
  color: #7b7b7b;
}

.select_text:disabled{
  appearance: none;
}

.cost_content{
  clear: left;
  display: flex;
}

.cost_left_content{
  /*border-top: 1px solid #99d9ea;*/
  width: 75%;
}

.cost_left_total{
  display: flex;
  width: 100%;
  border-bottom: 1px solid #8e8e8e;
}

.cost_left_row{
  position: relative;
}

.cost_left_row_title{
  color: black;
  display: inline-block;
}

.cost_left_row1{
  position: relative;
}

.cost_detail{
  position: absolute;
  left: 0;
  background-color: #dbedfc;
  color: black;
  z-index: 20;
  border: 1px solid #a8a8a8;
  margin: -6px 0 0 6rem;
  width: 50rem;
  font-size: 0.8rem;
  line-height: 1.4rem;
  border-radius: 0.6rem;
  padding: 0.5rem;
}

.cost_detail:after{
  content: '';
  position: absolute;
  top: 20px;
  left: -6px;
  width: 10px;
  height: 10px;
  margin-top: -10px;
  background: inherit;
  /*自动继承父元素的背景*/
  transform: rotate(45deg);
  border-left: 1px solid #a8a8a8;
  border-bottom: 1px solid #a8a8a8;
}

.cost_detail3{
  position: absolute;
  left: -610px;
  background-color: #dbedfc;
  color: black;
  z-index: 20;
  border: 1px solid #a8a8a8;
  margin: -6px 0 0 6rem;
  width: 50rem;
  font-size: 0.8rem;
  line-height: 1.4rem;
  border-radius: 0.6rem;
  padding: 0.5rem;
}

.cost_detail3:after{
  content: '';
  position: absolute;
  top: 20px;
  right: -6px;
  width: 10px;
  height: 10px;
  margin-top: -10px;
  background: inherit;
  /*自动继承父元素的背景*/
  transform: rotate(45deg);
  border-right: 1px solid #a8a8a8;
  border-top: 1px solid #a8a8a8;
}

.cost_detail1{
  position: absolute;
  left: 0;
  background-color: #dbedfc;
  color: black;
  z-index: 20;
  border: 1px solid #a8a8a8;
  margin: -6px 0 0 6rem;
  width: 70rem;
  font-size: 0.8rem;
  line-height: 1.4rem;
  border-radius: 0.6rem;
  padding: 0.5rem;
  top: -80px;
}

.cost_detail1:after{
  content: '';
  position: absolute;
  top: 100px;
  left: -6px;
  width: 10px;
  height: 10px;
  margin-top: -10px;
  background: inherit;
  /*自动继承父元素的背景*/
  transform: rotate(45deg);
  border-left: 1px solid #a8a8a8;
  border-bottom: 1px solid #a8a8a8;
}

.cost_detail2{
  position: absolute;
  left: -650px;
  background-color: #dbedfc;
  color: black;
  z-index: 20;
  border: 1px solid #a8a8a8;
  margin: -6px 0 0 6rem;
  width: 18rem;
  font-size: 0.8rem;
  line-height: 1.4rem;
  border-radius: 0.6rem;
  padding: 0.5rem;
}

.cost_detail2:after{
  content: '';
  position: absolute;
  top: 35px;
  right: -6px;
  width: 10px;
  height: 10px;
  margin-top: -10px;
  background: inherit;
  /*自动继承父元素的背景*/
  transform: rotate(45deg);
  border-right: 1px solid #a8a8a8;
  border-top: 1px solid #a8a8a8;
}

.cost_left_row_right, .cost_right_row_right{
  color: rgba(224, 30, 30, 0.97);
}

.cost_left_row_right{
  display: inline-block;
  text-align: start;
  position: relative;
}

.cost_left_row_right--none{
  color: #c8c8c9;
}

.cost_right_row_right{
  font-weight: 600;
}

.cost_left_bottom{
  display: flex;
  justify-content: space-between;
}

.left_bottom_left{
  font-weight: 600;
  color: rgba(224, 30, 30, 0.97);
}

.left_bottom_right{
  font-weight: 600;
  color: rgba(224, 30, 30, 0.97);
  display: flex;
  align-items: center;
}

.cost_right_content{
  /*border-top: 1px solid #99d9ea;*/
  width: 25%;
  margin-left: 40px;
}

.btn{
  /*text-align: end;*/
  position: absolute;
  right: 0;
  bottom: 17px;
}

.calm_button{
  color: white;
  background-color: #00a0c7;
  border: none;
  /* background-color: #0074bf; */
  /* border: 1px solid #07629e; */
  font-weight: bold;
  outline: none;
}

.calm_button:hover{
  opacity: .8;
  cursor: pointer;
}

.curr_self{
  color: #00a0c7;
  font-weight: 600;
}

input[disabled],input:disabled,input.disabled{
  color: #e8e8e8;
  -webkit-text-fill-color: #c7b7b7;
  background-color: #f1f1f1;
  opacity: 1;
}

select[disabled],select:disabled,select.disabled{
  color: #e8e8e8;
  -webkit-text-fill-color: #c7b7b7;
  background-color: #f1f1f1;
  opacity: 1;
}

.input_item{
  margin-bottom: 20px;
}

.input_box{
  width: 340px;
  height: 40px;
  font-size: 14px;
  outline: none;
  margin-left: 10px;
  padding: 0 10px;
  color: #5e5e5e;
  border: 1px solid #e6e6e6;
}

.login_content{
  width: 500px;
  height: 450px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.login_fun{
  width: 340px;
  display: flex;
  /*justify-content: space-between;*/
  justify-content: flex-end;
}

/*.login_fun span:hover{*/
/*  opacity: .8;*/
/*  cursor: pointer;*/
/*}*/

.login_btn_div{
  width: 340px;
  text-align: end;
  margin-top: 20px;
}

.login_btn{
  background-color: #00dfe3;
  color: white;
  padding: 10px 20px;
  border: none;
  width: 100%;
  outline: none;
}

.login_btn:hover{
  opacity: .8;
  cursor: pointer;
}

.checkbox_module{
  display: flex;
  font-size: 10px;
  margin-top: 15px;
}

.my_sent_btn{
  width: 100px;
  padding: 10px;
  text-align: center;
  background-color: #fff;
  border-bottom-right-radius: 5px;
  border-top-right-radius: 5px;
  border-left: 1px solid #8d8d8d;
}

.my_sent_btn1{
  width: 100px;
  padding: 10px;
  background-color: #fff;
  border-bottom-right-radius: 5px;
  border-top-right-radius: 5px;
  border-left: 1px solid #8d8d8d;
  text-align: center;
}

.my_sent_btn:hover{
  opacity: .8;
  cursor: pointer;
}

.checkbox_module span{
  color: #00a0c7;
  border-bottom: 1px solid #00a0c7;
}

.checkbox_module span:hover{
  cursor: pointer;
  border-bottom: none;
}

.registered_content{
  margin: 50px 0;
  width: 1000px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.input_info{
  position: relative;
}

.my_input{
  height: 40px;
  width: 300px;
  border: 1px solid #8d8d8d;
  margin: 10px 0;
  display: flex;
}

.my_input input{
  border: none;
  height: 30px;
}

.input_info span{
  position: absolute;
  top: 12px;
  font-size: 12px;
  width: 300px;
  border: 1px solid #e6e6e6;
  border-radius: 2px;
  background-color: #fafafa;
  padding: 10px;
}

.input_info span:after{
  content: '';
  position: absolute;
  top: 20px;
  left: -6px;
  width: 10px;
  height: 10px;
  margin-top: -10px;
  background: inherit;
  /*自动继承父元素的背景*/
  transform: rotate(45deg);
  border-left: 1px solid #e6e6e6;
  border-bottom: 1px solid #e6e6e6;
}

.input_info span p{
  margin: 5px;
}

.registered_btn_div{
  width: 340px;
  text-align: center;
  margin-top: 20px;
}

.registered_btn{
  background-color: #00dfe3;
  color: white;
  padding: 10px 20px;
  border: none;
  width: 90%;
}

.registered_btn:hover{
  cursor: pointer;
  opacity: .8;
}

.registered_btn[disabled]{
  background-color: #cccccc;
}

.registered_btn[disabled]:hover{
  cursor: initial;
  opacity: 1;
}


.my_send button{
  padding: 5px 20px;
  outline: none;
}

.my_send button:hover{
  opacity: .8;
  cursor: pointer;
}

.registered_input{
  height: 40px;
  margin: 5px 10px;
  width: 300px;
  border: 1px solid #8d8d8d;
  outline: none;
  padding: 10px;
  font-size: 12px;
  color: #8b8b8b;
}

.registered_input_1{
  height: 40px;
  margin: 5px 10px;
  width: 150px;
  border: 1px solid #8d8d8d;
  outline: none;
  padding: 10px;
  font-size: 12px;
  color: #8b8b8b;
}

.verity_img{
  width: 150px;
  height: 50px;
  margin-bottom: -10px;
}

.phone_input_module{
  display: flex;
  border: 1px solid #8d8d8d;
  margin: 10px;
  width: 300px;
}

.phone_input_module input{
  height: 40px;
  border: none;
}

.phone_name{
  width: 40px;
  text-align: center;
  outline: none;
  padding: 10px;
  font-size: 12px;
  color: #8b8b8b;
}

.phone_input{
  width: 258px;
  outline: none;
  padding: 10px;
  font-size: 12px;
  color: #8b8b8b;
}

.input_info div{
  float: right;
}

.input_box_2{
  width: 170px;
  height: 30px;
  font-size: 16px;
  outline: none;
  margin-right: 20px;
}

.login_close{
  position: absolute;
  top: 0;
  right: 0;
  width: 30px;
  height: 30px;
  margin: 10px
}

.login_close:hover{
  opacity: .8;
  cursor: pointer;
}

.top_input{
  border: 1px solid #7f9db9;
  outline: none;
  text-align: center;
  color: #7b7b7b;
}

.input_item_title{
  position: relative;
}

.input_item_detail, .input_item_detail1 {
  position: absolute;
  background-color: #dbedfc;
  color: black;
  z-index: 20;
  border: 1px solid #a8a8a8;
  text-align: start;
}

.input_item_detail3{
  position: absolute;
  background-color: #dbedfc;
  color: black;
  z-index: 20;
  border: 1px solid #a8a8a8;
  text-align: start;
  right: 80px;
}

.input_item_detail1{
  right: 90px;
}

.input_item_detail:after, .input_item_detail1:after,.input_item_detail2:after{
  content: '';
  position: absolute;
  top: 20px;
  width: 10px;
  height: 10px;
  margin-top: -10px;
  background: inherit;
  /*自动继承父元素的背景*/
  transform: rotate(45deg);
}

.input_item_detail3:after{
  /* left: -406px; */
  right: -6px;
  border-right: 1px solid #a8a8a8;
  border-top: 1px solid #a8a8a8;
  content: '';
  position: absolute;
  top: 20px;
  width: 10px;
  height: 10px;
  margin-top: -10px;
  background: inherit;
  /*自动继承父元素的背景*/
  transform: rotate(45deg);
}

.input_item_detail1:after{
  right: -6px;
  border-right: 1px solid #a8a8a8;
  border-top: 1px solid #a8a8a8;
}

.input_item_detail:after{
  left: -6px;
  border-left: 1px solid #a8a8a8;
  border-bottom: 1px solid #a8a8a8;
}

.isInput{
  border: 1px solid red;
}

.isDisable{
  background-color: #eeeeee;
}

.disInput{
  background-color: #f1f1f1;
  opacity: 1;
}

.title_orange{
  color: #fca605;
}

.disable_text{
  // font-size: 8px;
  padding-left: 10px;
  border: none;
}

.change_text{
  display: block;
  float: left;
  font-size: 12px;
  background-color: #ff7f27;
  color: white;
  padding: 5px 10px;
  border-radius: 5px;
  margin-right: 5px;
}

.change_text:hover{
  cursor: pointer;
  opacity: .8;
}

.input_item_detail2{
  position: absolute;
  background-color: #dbedfc;
  color: black;
  top: -200px;
  /*left: 0px;*/
  /*margin: -6px 0 0 5px;*/
  margin: 25px 0 0 0;
  z-index: 10;
  width: 750px;
  font-size: 8px;
  line-height: 15px;
  border: 1px solid #a8a8a8;
  border-radius: 8px;
  padding: 5px;
}

.input_item_detail2:after{
  left: -6px;
  top: 185px;
  border-left: 1px solid #a8a8a8;
  border-bottom: 1px solid #a8a8a8;
  /*border-top: 1px solid #a8a8a8;*/
}
.new_tips{
  /*color: #00a0c7;*/
  color: #ff7f17;
  margin: 10px 0 10px 20px;
  font-size: 12px;
  font-weight: 800;
  position: absolute;
}

.num-margin{
  margin-left: 3px;
}

.bottom-text{
  color: #ff7f17;
  position: absolute;
  bottom: 10px;
  text-align: center;
  /*font-weight: bold;*/
  font-size: 12px;
}

.free-register{
  color: #00a0c7;
  border-bottom: 1px solid #00a0c7;
  font-weight: bold;
  margin-left: 5px;
}

.free-register:hover{
  opacity: .8;
  cursor: pointer;
}

.question-img{
    width: 12px;
    /* position: absolute; */
  }
</style>
